/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type NavigationNode = {
  __typename: "NavigationNode";
  id?: string;
  label?: string;
  image?: string;
  description?: string | null;
  active?: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID?: string;
  createdAt?: string;
  updatedAt?: string;
  institution?: Institution;
  modules?: ModelModuleConnection;
  parentConnection?: NavigationNodeConnection;
  childConnections?: ModelNavigationNodeConnectionConnection;
};

export type Institution = {
  __typename: "Institution";
  id?: string;
  name?: string;
  logo?: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt?: string;
  updatedAt?: string;
  contents?: ModelContentConnection;
  modules?: ModelModuleConnection;
  navigationNodes?: ModelNavigationNodeConnection;
  navigationNodeConnections?: ModelNavigationNodeConnectionConnection;
  users?: ModelUserConnection;
};

export type ModelContentConnection = {
  __typename: "ModelContentConnection";
  items?: Array<Content>;
  nextToken?: string | null;
};

export type Content = {
  __typename: "Content";
  id?: string;
  type?: ContentType;
  value?: string;
  contentUserId?: string;
  createdAt?: string;
  updatedAt?: string;
  institution?: Institution;
  answers?: ModelAnswerContentConnection;
  modules?: ModelModuleContentConnection;
  questions?: ModelQuestionContentConnection;
  slides?: ModelSlideContentConnection;
  user?: User;
};

export enum ContentType {
  TEXT = "TEXT",
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
  STREAM_VIMEO = "STREAM_VIMEO",
  STREAM_YOUTUBE = "STREAM_YOUTUBE",
  MODEL = "MODEL"
}

export type ModelAnswerContentConnection = {
  __typename: "ModelAnswerContentConnection";
  items?: Array<AnswerContent>;
  nextToken?: string | null;
};

export type AnswerContent = {
  __typename: "AnswerContent";
  id?: string;
  order?: number;
  createdAt?: string;
  updatedAt?: string;
  answer?: Answer;
  content?: Content;
};

export type Answer = {
  __typename: "Answer";
  id?: string;
  correctness?: number;
  default?: boolean | null;
  createdAt?: string;
  updatedAt?: string;
  choices?: ModelAnswerChoiceConnection;
  contents?: ModelAnswerContentConnection;
  question?: Question;
};

export type ModelAnswerChoiceConnection = {
  __typename: "ModelAnswerChoiceConnection";
  items?: Array<AnswerChoice>;
  nextToken?: string | null;
};

export type AnswerChoice = {
  __typename: "AnswerChoice";
  id?: string;
  choiceId?: string;
  createdAt?: string;
  updatedAt?: string;
  answer?: Answer;
  choice?: Choice;
};

export type Choice = {
  __typename: "Choice";
  id?: string;
  value?: string;
  order?: number;
  createdAt?: string;
  updatedAt?: string;
  question?: Question;
};

export type Question = {
  __typename: "Question";
  id?: string;
  value?: string;
  description?: string | null;
  type?: QuestionType;
  data?: string | null;
  createdAt?: string;
  updatedAt?: string;
  answers?: ModelAnswerConnection;
  choices?: ModelChoiceConnection;
  module?: Module;
  page?: Page;
  contents?: ModelQuestionContentConnection;
};

export enum QuestionType {
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  MULTIPLE_SELECT = "MULTIPLE_SELECT",
  SHORT_FORM = "SHORT_FORM",
  LONG_FORM = "LONG_FORM",
  LIKERT = "LIKERT"
}

export type ModelAnswerConnection = {
  __typename: "ModelAnswerConnection";
  items?: Array<Answer>;
  nextToken?: string | null;
};

export type ModelChoiceConnection = {
  __typename: "ModelChoiceConnection";
  items?: Array<Choice>;
  nextToken?: string | null;
};

export type Module = {
  __typename: "Module";
  id?: string;
  label?: string;
  image?: string;
  description?: string | null;
  order?: number;
  active?: boolean;
  locked?: boolean | null;
  type?: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID?: string;
  navigationNodeID?: string;
  createdAt?: string;
  updatedAt?: string;
  institution?: Institution;
  contents?: ModelModuleContentConnection;
  navigationNode?: NavigationNode;
  pages?: ModelPageConnection;
  questions?: ModelQuestionConnection;
  runs?: ModelRunConnection;
};

export enum ModuleType {
  TEST = "TEST",
  SURVEY = "SURVEY",
  SLIDESHOW = "SLIDESHOW"
}

export type ModelModuleContentConnection = {
  __typename: "ModelModuleContentConnection";
  items?: Array<ModuleContent>;
  nextToken?: string | null;
};

export type ModuleContent = {
  __typename: "ModuleContent";
  id?: string;
  order?: number;
  createdAt?: string;
  updatedAt?: string;
  content?: Content;
  module?: Module;
};

export type ModelPageConnection = {
  __typename: "ModelPageConnection";
  items?: Array<Page>;
  nextToken?: string | null;
};

export type Page = {
  __typename: "Page";
  id?: string;
  order?: number;
  type?: PageType;
  createdAt?: string;
  updatedAt?: string;
  module?: Module;
  question?: Question;
  slide?: Slide;
};

export enum PageType {
  QUESTION = "QUESTION",
  SLIDE = "SLIDE"
}

export type Slide = {
  __typename: "Slide";
  pageID?: string;
  notes?: string | null;
  createdAt?: string;
  updatedAt?: string;
  page?: Page;
  contents?: ModelSlideContentConnection;
};

export type ModelSlideContentConnection = {
  __typename: "ModelSlideContentConnection";
  items?: Array<SlideContent>;
  nextToken?: string | null;
};

export type SlideContent = {
  __typename: "SlideContent";
  id?: string;
  order?: number;
  createdAt?: string;
  updatedAt?: string;
  content?: Content;
  slide?: Slide;
};

export type ModelQuestionConnection = {
  __typename: "ModelQuestionConnection";
  items?: Array<Question>;
  nextToken?: string | null;
};

export type ModelRunConnection = {
  __typename: "ModelRunConnection";
  items?: Array<Run>;
  nextToken?: string | null;
};

export type Run = {
  __typename: "Run";
  moduleID?: string;
  userID?: string;
  createdAt?: string;
  updatedAt?: string;
  module?: Module;
  responses?: ModelResponseConnection;
  user?: User;
};

export type ModelResponseConnection = {
  __typename: "ModelResponseConnection";
  items?: Array<Response>;
  nextToken?: string | null;
};

export type Response = {
  __typename: "Response";
  id?: string;
  moduleID?: string;
  questionID?: string;
  userID?: string;
  value?: string | null;
  correctness?: number | null;
  createdAt?: string;
  updatedAt?: string;
  choices?: ModelResponseChoiceConnection;
  run?: Run;
  user?: User;
};

export type ModelResponseChoiceConnection = {
  __typename: "ModelResponseChoiceConnection";
  items?: Array<ResponseChoice>;
  nextToken?: string | null;
};

export type ResponseChoice = {
  __typename: "ResponseChoice";
  id?: string;
  responseID?: string;
  choiceID?: string;
  createdAt?: string;
  updatedAt?: string;
  choice?: Choice;
};

export type User = {
  __typename: "User";
  id?: string;
  createdAt?: string;
  updatedAt?: string;
  institution?: Institution;
  contents?: ModelContentConnection;
  modules?: ModelModuleConnection;
  navigationNodes?: ModelNavigationNodeConnection;
  responses?: ModelResponseConnection;
  runs?: ModelRunConnection;
};

export type ModelModuleConnection = {
  __typename: "ModelModuleConnection";
  items?: Array<Module>;
  nextToken?: string | null;
};

export type ModelNavigationNodeConnection = {
  __typename: "ModelNavigationNodeConnection";
  items?: Array<NavigationNode>;
  nextToken?: string | null;
};

export type ModelQuestionContentConnection = {
  __typename: "ModelQuestionContentConnection";
  items?: Array<QuestionContent>;
  nextToken?: string | null;
};

export type QuestionContent = {
  __typename: "QuestionContent";
  id?: string;
  order?: number;
  createdAt?: string;
  updatedAt?: string;
  content?: Content;
  question?: Question;
};

export type ModelNavigationNodeConnectionConnection = {
  __typename: "ModelNavigationNodeConnectionConnection";
  items?: Array<NavigationNodeConnection>;
  nextToken?: string | null;
};

export type NavigationNodeConnection = {
  __typename: "NavigationNodeConnection";
  id?: string;
  order?: number;
  parentId?: string;
  createdAt?: string;
  updatedAt?: string;
  institution?: Institution;
  child?: NavigationNode;
  parent?: NavigationNode;
};

export type ModelUserConnection = {
  __typename: "ModelUserConnection";
  items?: Array<User>;
  nextToken?: string | null;
};

export type CreateInstitutionInput = {
  id?: string | null;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
};

export type ModelInstitutionConditionInput = {
  name?: ModelStringInput | null;
  logo?: ModelStringInput | null;
  navigationNodeLevelNames?: ModelStringInput | null;
  and?: Array<ModelInstitutionConditionInput | null> | null;
  or?: Array<ModelInstitutionConditionInput | null> | null;
  not?: ModelInstitutionConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type UpdateInstitutionInput = {
  id: string;
  name?: string | null;
  logo?: string | null;
  navigationNodeLevelNames?: Array<string | null> | null;
};

export type DeleteInstitutionInput = {
  id: string;
};

export type CreateAnswerInput = {
  id?: string | null;
  correctness: number;
  default?: boolean | null;
  answerQuestionId?: string | null;
};

export type ModelAnswerConditionInput = {
  correctness?: ModelIntInput | null;
  default?: ModelBooleanInput | null;
  and?: Array<ModelAnswerConditionInput | null> | null;
  or?: Array<ModelAnswerConditionInput | null> | null;
  not?: ModelAnswerConditionInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UpdateAnswerInput = {
  id: string;
  correctness?: number | null;
  default?: boolean | null;
  answerQuestionId?: string | null;
};

export type DeleteAnswerInput = {
  id: string;
};

export type CreateAnswerChoiceInput = {
  id?: string | null;
  choiceId: string;
  answerChoiceAnswerId?: string | null;
};

export type ModelAnswerChoiceConditionInput = {
  choiceId?: ModelIDInput | null;
  and?: Array<ModelAnswerChoiceConditionInput | null> | null;
  or?: Array<ModelAnswerChoiceConditionInput | null> | null;
  not?: ModelAnswerChoiceConditionInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type UpdateAnswerChoiceInput = {
  id: string;
  choiceId?: string | null;
  answerChoiceAnswerId?: string | null;
};

export type DeleteAnswerChoiceInput = {
  id: string;
};

export type CreateAnswerContentInput = {
  id?: string | null;
  order: number;
  answerContentAnswerId?: string | null;
  answerContentContentId?: string | null;
};

export type ModelAnswerContentConditionInput = {
  order?: ModelIntInput | null;
  and?: Array<ModelAnswerContentConditionInput | null> | null;
  or?: Array<ModelAnswerContentConditionInput | null> | null;
  not?: ModelAnswerContentConditionInput | null;
};

export type UpdateAnswerContentInput = {
  id: string;
  order?: number | null;
  answerContentAnswerId?: string | null;
  answerContentContentId?: string | null;
};

export type DeleteAnswerContentInput = {
  id: string;
};

export type CreateChoiceInput = {
  id?: string | null;
  value: string;
  order: number;
  choiceQuestionId?: string | null;
};

export type ModelChoiceConditionInput = {
  value?: ModelStringInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelChoiceConditionInput | null> | null;
  or?: Array<ModelChoiceConditionInput | null> | null;
  not?: ModelChoiceConditionInput | null;
};

export type UpdateChoiceInput = {
  id: string;
  value?: string | null;
  order?: number | null;
  choiceQuestionId?: string | null;
};

export type DeleteChoiceInput = {
  id: string;
};

export type CreateContentInput = {
  id?: string | null;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt?: string | null;
  contentInstitutionId: string;
};

export type ModelContentConditionInput = {
  type?: ModelContentTypeInput | null;
  value?: ModelStringInput | null;
  contentUserId?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelContentConditionInput | null> | null;
  or?: Array<ModelContentConditionInput | null> | null;
  not?: ModelContentConditionInput | null;
};

export type ModelContentTypeInput = {
  eq?: ContentType | null;
  ne?: ContentType | null;
};

export type UpdateContentInput = {
  id: string;
  type?: ContentType | null;
  value?: string | null;
  contentUserId?: string | null;
  createdAt?: string | null;
  contentInstitutionId?: string | null;
};

export type DeleteContentInput = {
  id: string;
};

export type CreateModuleInput = {
  id?: string | null;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  moduleInstitutionId?: string | null;
};

export type ModelModuleConditionInput = {
  label?: ModelStringInput | null;
  image?: ModelStringInput | null;
  description?: ModelStringInput | null;
  order?: ModelIntInput | null;
  active?: ModelBooleanInput | null;
  locked?: ModelBooleanInput | null;
  type?: ModelModuleTypeInput | null;
  visible?: ModelBooleanInput | null;
  public?: ModelBooleanInput | null;
  ownerID?: ModelIDInput | null;
  navigationNodeID?: ModelIDInput | null;
  and?: Array<ModelModuleConditionInput | null> | null;
  or?: Array<ModelModuleConditionInput | null> | null;
  not?: ModelModuleConditionInput | null;
};

export type ModelModuleTypeInput = {
  eq?: ModuleType | null;
  ne?: ModuleType | null;
};

export type UpdateModuleInput = {
  id: string;
  label?: string | null;
  image?: string | null;
  description?: string | null;
  order?: number | null;
  active?: boolean | null;
  locked?: boolean | null;
  type?: ModuleType | null;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID?: string | null;
  navigationNodeID?: string | null;
  moduleInstitutionId?: string | null;
};

export type DeleteModuleInput = {
  id: string;
};

export type CreateModuleContentInput = {
  id?: string | null;
  order: number;
  moduleContentModuleId?: string | null;
  moduleContentContentId?: string | null;
};

export type ModelModuleContentConditionInput = {
  order?: ModelIntInput | null;
  and?: Array<ModelModuleContentConditionInput | null> | null;
  or?: Array<ModelModuleContentConditionInput | null> | null;
  not?: ModelModuleContentConditionInput | null;
};

export type UpdateModuleContentInput = {
  id: string;
  order?: number | null;
  moduleContentModuleId?: string | null;
  moduleContentContentId?: string | null;
};

export type DeleteModuleContentInput = {
  id: string;
};

export type CreateNavigationNodeInput = {
  id?: string | null;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  navigationNodeInstitutionId: string;
};

export type ModelNavigationNodeConditionInput = {
  label?: ModelStringInput | null;
  image?: ModelStringInput | null;
  description?: ModelStringInput | null;
  active?: ModelBooleanInput | null;
  order?: ModelIntInput | null;
  visible?: ModelBooleanInput | null;
  ownerID?: ModelIDInput | null;
  and?: Array<ModelNavigationNodeConditionInput | null> | null;
  or?: Array<ModelNavigationNodeConditionInput | null> | null;
  not?: ModelNavigationNodeConditionInput | null;
};

export type UpdateNavigationNodeInput = {
  id: string;
  label?: string | null;
  image?: string | null;
  description?: string | null;
  active?: boolean | null;
  order?: number | null;
  visible?: boolean | null;
  ownerID?: string | null;
  navigationNodeInstitutionId?: string | null;
};

export type DeleteNavigationNodeInput = {
  id: string;
};

export type CreateNavigationNodeConnectionInput = {
  id?: string | null;
  order: number;
  parentId: string;
  navigationNodeConnectionInstitutionId: string;
};

export type ModelNavigationNodeConnectionConditionInput = {
  order?: ModelIntInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelNavigationNodeConnectionConditionInput | null> | null;
  or?: Array<ModelNavigationNodeConnectionConditionInput | null> | null;
  not?: ModelNavigationNodeConnectionConditionInput | null;
};

export type UpdateNavigationNodeConnectionInput = {
  id: string;
  order?: number | null;
  parentId?: string | null;
  navigationNodeConnectionInstitutionId?: string | null;
};

export type DeleteNavigationNodeConnectionInput = {
  id: string;
};

export type CreatePageInput = {
  id?: string | null;
  order: number;
  type: PageType;
  pageModuleId?: string | null;
  pageQuestionId?: string | null;
};

export type ModelPageConditionInput = {
  order?: ModelIntInput | null;
  type?: ModelPageTypeInput | null;
  and?: Array<ModelPageConditionInput | null> | null;
  or?: Array<ModelPageConditionInput | null> | null;
  not?: ModelPageConditionInput | null;
};

export type ModelPageTypeInput = {
  eq?: PageType | null;
  ne?: PageType | null;
};

export type UpdatePageInput = {
  id: string;
  order?: number | null;
  type?: PageType | null;
  pageModuleId?: string | null;
  pageQuestionId?: string | null;
};

export type DeletePageInput = {
  id: string;
};

export type CreateQuestionInput = {
  id?: string | null;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  questionModuleId?: string | null;
  questionPageId?: string | null;
};

export type ModelQuestionConditionInput = {
  value?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelQuestionTypeInput | null;
  data?: ModelStringInput | null;
  and?: Array<ModelQuestionConditionInput | null> | null;
  or?: Array<ModelQuestionConditionInput | null> | null;
  not?: ModelQuestionConditionInput | null;
};

export type ModelQuestionTypeInput = {
  eq?: QuestionType | null;
  ne?: QuestionType | null;
};

export type UpdateQuestionInput = {
  id: string;
  value?: string | null;
  description?: string | null;
  type?: QuestionType | null;
  data?: string | null;
  questionModuleId?: string | null;
  questionPageId?: string | null;
};

export type DeleteQuestionInput = {
  id: string;
};

export type CreateQuestionContentInput = {
  id?: string | null;
  order: number;
  questionContentQuestionId?: string | null;
  questionContentContentId?: string | null;
};

export type ModelQuestionContentConditionInput = {
  order?: ModelIntInput | null;
  and?: Array<ModelQuestionContentConditionInput | null> | null;
  or?: Array<ModelQuestionContentConditionInput | null> | null;
  not?: ModelQuestionContentConditionInput | null;
};

export type UpdateQuestionContentInput = {
  id: string;
  order?: number | null;
  questionContentQuestionId?: string | null;
  questionContentContentId?: string | null;
};

export type DeleteQuestionContentInput = {
  id: string;
};

export type CreateResponseInput = {
  id?: string | null;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt?: string | null;
};

export type ModelResponseConditionInput = {
  value?: ModelStringInput | null;
  correctness?: ModelIntInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelResponseConditionInput | null> | null;
  or?: Array<ModelResponseConditionInput | null> | null;
  not?: ModelResponseConditionInput | null;
};

export type UpdateResponseInput = {
  id?: string | null;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt?: string | null;
};

export type DeleteResponseInput = {
  moduleID: string;
  userID: string;
  questionID: string;
};

export type CreateResponseChoiceInput = {
  id?: string | null;
  responseID: string;
  choiceID: string;
};

export type ModelResponseChoiceConditionInput = {
  responseID?: ModelIDInput | null;
  choiceID?: ModelIDInput | null;
  and?: Array<ModelResponseChoiceConditionInput | null> | null;
  or?: Array<ModelResponseChoiceConditionInput | null> | null;
  not?: ModelResponseChoiceConditionInput | null;
};

export type UpdateResponseChoiceInput = {
  id: string;
  responseID?: string | null;
  choiceID?: string | null;
};

export type DeleteResponseChoiceInput = {
  id: string;
};

export type CreateRunInput = {
  moduleID: string;
  userID: string;
};

export type ModelRunConditionInput = {
  and?: Array<ModelRunConditionInput | null> | null;
  or?: Array<ModelRunConditionInput | null> | null;
  not?: ModelRunConditionInput | null;
};

export type UpdateRunInput = {
  moduleID: string;
  userID: string;
};

export type DeleteRunInput = {
  moduleID: string;
  userID: string;
};

export type CreateSlideInput = {
  pageID: string;
  notes?: string | null;
};

export type ModelSlideConditionInput = {
  notes?: ModelStringInput | null;
  and?: Array<ModelSlideConditionInput | null> | null;
  or?: Array<ModelSlideConditionInput | null> | null;
  not?: ModelSlideConditionInput | null;
};

export type UpdateSlideInput = {
  pageID: string;
  notes?: string | null;
};

export type DeleteSlideInput = {
  pageID: string;
};

export type CreateSlideContentInput = {
  id?: string | null;
  order: number;
  slideContentSlideId?: string | null;
  slideContentContentId?: string | null;
};

export type ModelSlideContentConditionInput = {
  order?: ModelIntInput | null;
  and?: Array<ModelSlideContentConditionInput | null> | null;
  or?: Array<ModelSlideContentConditionInput | null> | null;
  not?: ModelSlideContentConditionInput | null;
};

export type UpdateSlideContentInput = {
  id: string;
  order?: number | null;
  slideContentSlideId?: string | null;
  slideContentContentId?: string | null;
};

export type DeleteSlideContentInput = {
  id: string;
};

export type CreateUserInput = {
  id?: string | null;
  userInstitutionId?: string | null;
};

export type ModelUserConditionInput = {
  and?: Array<ModelUserConditionInput | null> | null;
  or?: Array<ModelUserConditionInput | null> | null;
  not?: ModelUserConditionInput | null;
};

export type UpdateUserInput = {
  id: string;
  userInstitutionId?: string | null;
};

export type DeleteUserInput = {
  id: string;
};

export type ModelInstitutionFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  logo?: ModelStringInput | null;
  navigationNodeLevelNames?: ModelStringInput | null;
  and?: Array<ModelInstitutionFilterInput | null> | null;
  or?: Array<ModelInstitutionFilterInput | null> | null;
  not?: ModelInstitutionFilterInput | null;
};

export type ModelInstitutionConnection = {
  __typename: "ModelInstitutionConnection";
  items?: Array<Institution>;
  nextToken?: string | null;
};

export type ModelAnswerFilterInput = {
  id?: ModelIDInput | null;
  correctness?: ModelIntInput | null;
  default?: ModelBooleanInput | null;
  and?: Array<ModelAnswerFilterInput | null> | null;
  or?: Array<ModelAnswerFilterInput | null> | null;
  not?: ModelAnswerFilterInput | null;
};

export type ModelAnswerChoiceFilterInput = {
  id?: ModelIDInput | null;
  choiceId?: ModelIDInput | null;
  and?: Array<ModelAnswerChoiceFilterInput | null> | null;
  or?: Array<ModelAnswerChoiceFilterInput | null> | null;
  not?: ModelAnswerChoiceFilterInput | null;
};

export type ModelAnswerContentFilterInput = {
  id?: ModelIDInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelAnswerContentFilterInput | null> | null;
  or?: Array<ModelAnswerContentFilterInput | null> | null;
  not?: ModelAnswerContentFilterInput | null;
};

export type ModelChoiceFilterInput = {
  id?: ModelIDInput | null;
  value?: ModelStringInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelChoiceFilterInput | null> | null;
  or?: Array<ModelChoiceFilterInput | null> | null;
  not?: ModelChoiceFilterInput | null;
};

export type ModelContentFilterInput = {
  id?: ModelIDInput | null;
  type?: ModelContentTypeInput | null;
  value?: ModelStringInput | null;
  contentUserId?: ModelIDInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelContentFilterInput | null> | null;
  or?: Array<ModelContentFilterInput | null> | null;
  not?: ModelContentFilterInput | null;
};

export type ModelStringKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC"
}

export type ModelModuleFilterInput = {
  id?: ModelIDInput | null;
  label?: ModelStringInput | null;
  image?: ModelStringInput | null;
  description?: ModelStringInput | null;
  order?: ModelIntInput | null;
  active?: ModelBooleanInput | null;
  locked?: ModelBooleanInput | null;
  type?: ModelModuleTypeInput | null;
  visible?: ModelBooleanInput | null;
  public?: ModelBooleanInput | null;
  ownerID?: ModelIDInput | null;
  navigationNodeID?: ModelIDInput | null;
  and?: Array<ModelModuleFilterInput | null> | null;
  or?: Array<ModelModuleFilterInput | null> | null;
  not?: ModelModuleFilterInput | null;
};

export type ModelModuleContentFilterInput = {
  id?: ModelIDInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelModuleContentFilterInput | null> | null;
  or?: Array<ModelModuleContentFilterInput | null> | null;
  not?: ModelModuleContentFilterInput | null;
};

export type ModelNavigationNodeFilterInput = {
  id?: ModelIDInput | null;
  label?: ModelStringInput | null;
  image?: ModelStringInput | null;
  description?: ModelStringInput | null;
  active?: ModelBooleanInput | null;
  order?: ModelIntInput | null;
  visible?: ModelBooleanInput | null;
  ownerID?: ModelIDInput | null;
  and?: Array<ModelNavigationNodeFilterInput | null> | null;
  or?: Array<ModelNavigationNodeFilterInput | null> | null;
  not?: ModelNavigationNodeFilterInput | null;
};

export type ModelNavigationNodeConnectionFilterInput = {
  id?: ModelIDInput | null;
  order?: ModelIntInput | null;
  parentId?: ModelIDInput | null;
  and?: Array<ModelNavigationNodeConnectionFilterInput | null> | null;
  or?: Array<ModelNavigationNodeConnectionFilterInput | null> | null;
  not?: ModelNavigationNodeConnectionFilterInput | null;
};

export type ModelPageFilterInput = {
  id?: ModelIDInput | null;
  order?: ModelIntInput | null;
  type?: ModelPageTypeInput | null;
  and?: Array<ModelPageFilterInput | null> | null;
  or?: Array<ModelPageFilterInput | null> | null;
  not?: ModelPageFilterInput | null;
};

export type ModelQuestionFilterInput = {
  id?: ModelIDInput | null;
  value?: ModelStringInput | null;
  description?: ModelStringInput | null;
  type?: ModelQuestionTypeInput | null;
  data?: ModelStringInput | null;
  and?: Array<ModelQuestionFilterInput | null> | null;
  or?: Array<ModelQuestionFilterInput | null> | null;
  not?: ModelQuestionFilterInput | null;
};

export type ModelQuestionContentFilterInput = {
  id?: ModelIDInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelQuestionContentFilterInput | null> | null;
  or?: Array<ModelQuestionContentFilterInput | null> | null;
  not?: ModelQuestionContentFilterInput | null;
};

export type ModelResponsePrimaryCompositeKeyConditionInput = {
  eq?: ModelResponsePrimaryCompositeKeyInput | null;
  le?: ModelResponsePrimaryCompositeKeyInput | null;
  lt?: ModelResponsePrimaryCompositeKeyInput | null;
  ge?: ModelResponsePrimaryCompositeKeyInput | null;
  gt?: ModelResponsePrimaryCompositeKeyInput | null;
  between?: Array<ModelResponsePrimaryCompositeKeyInput | null> | null;
  beginsWith?: ModelResponsePrimaryCompositeKeyInput | null;
};

export type ModelResponsePrimaryCompositeKeyInput = {
  userID?: string | null;
  questionID?: string | null;
};

export type ModelResponseFilterInput = {
  id?: ModelIDInput | null;
  moduleID?: ModelIDInput | null;
  questionID?: ModelIDInput | null;
  userID?: ModelIDInput | null;
  value?: ModelStringInput | null;
  correctness?: ModelIntInput | null;
  createdAt?: ModelStringInput | null;
  and?: Array<ModelResponseFilterInput | null> | null;
  or?: Array<ModelResponseFilterInput | null> | null;
  not?: ModelResponseFilterInput | null;
};

export type ModelResponseChoiceFilterInput = {
  id?: ModelIDInput | null;
  responseID?: ModelIDInput | null;
  choiceID?: ModelIDInput | null;
  and?: Array<ModelResponseChoiceFilterInput | null> | null;
  or?: Array<ModelResponseChoiceFilterInput | null> | null;
  not?: ModelResponseChoiceFilterInput | null;
};

export type ModelIDKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelRunFilterInput = {
  moduleID?: ModelIDInput | null;
  userID?: ModelIDInput | null;
  and?: Array<ModelRunFilterInput | null> | null;
  or?: Array<ModelRunFilterInput | null> | null;
  not?: ModelRunFilterInput | null;
};

export type ModelSlideFilterInput = {
  pageID?: ModelIDInput | null;
  notes?: ModelStringInput | null;
  and?: Array<ModelSlideFilterInput | null> | null;
  or?: Array<ModelSlideFilterInput | null> | null;
  not?: ModelSlideFilterInput | null;
};

export type ModelSlideConnection = {
  __typename: "ModelSlideConnection";
  items?: Array<Slide>;
  nextToken?: string | null;
};

export type ModelSlideContentFilterInput = {
  id?: ModelIDInput | null;
  order?: ModelIntInput | null;
  and?: Array<ModelSlideContentFilterInput | null> | null;
  or?: Array<ModelSlideContentFilterInput | null> | null;
  not?: ModelSlideContentFilterInput | null;
};

export type ModelUserFilterInput = {
  id?: ModelIDInput | null;
  and?: Array<ModelUserFilterInput | null> | null;
  or?: Array<ModelUserFilterInput | null> | null;
  not?: ModelUserFilterInput | null;
};

export type getNavigationNodeForUserQuery = {
  __typename: "NavigationNode";
  active: boolean;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    items: Array<{
      __typename: "NavigationNodeConnection";
      order: number;
      child?: {
        __typename: "NavigationNode";
        active: boolean;
        description?: string | null;
        id: string;
        image: string;
        label: string;
        childConnections?: {
          __typename: "ModelNavigationNodeConnectionConnection";
          items: Array<{
            __typename: "NavigationNodeConnection";
            child?: {
              __typename: "NavigationNode";
              active: boolean;
              visible?: boolean | null;
            } | null;
          }>;
        } | null;
        modules?: {
          __typename: "ModelModuleConnection";
          items: Array<{
            __typename: "Module";
            id: string;
            visible?: boolean | null;
          }>;
        } | null;
        visible?: boolean | null;
      } | null;
    }>;
    nextToken?: string | null;
  } | null;
  description?: string | null;
  id: string;
  institution: {
    __typename: "Institution";
    id: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    navigationNodeConnections?: {
      __typename: "ModelNavigationNodeConnectionConnection";
      items: Array<{
        __typename: "NavigationNodeConnection";
        id: string;
        parentId: string;
      }>;
    } | null;
    navigationNodes?: {
      __typename: "ModelNavigationNodeConnection";
      items: Array<{
        __typename: "NavigationNode";
        id: string;
        label: string;
      }>;
    } | null;
  };
  label: string;
  modules?: {
    __typename: "ModelModuleConnection";
    items: Array<{
      __typename: "Module";
      active: boolean;
      description?: string | null;
      id: string;
      image: string;
      label: string;
      order: number;
      visible?: boolean | null;
      public?: boolean | null;
      questions?: {
        __typename: "ModelQuestionConnection";
        items: Array<{
          __typename: "Question";
          id: string;
        }>;
      } | null;
      runs?: {
        __typename: "ModelRunConnection";
        items: Array<{
          __typename: "Run";
          responses?: {
            __typename: "ModelResponseConnection";
            items: Array<{
              __typename: "Response";
              id: string;
              questionID: string;
            }>;
          } | null;
        }>;
      } | null;
      type: ModuleType;
    }>;
    nextToken?: string | null;
  } | null;
};

export type getModuleForAdminQuery = {
  __typename: "Module";
  id: string;
  description?: string | null;
  order: number;
  image: string;
  label: string;
  type: ModuleType;
  active: boolean;
  visible?: boolean | null;
  locked?: boolean | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    items: Array<{
      __typename: "ModuleContent";
      order: number;
      content?: {
        __typename: "Content";
        id: string;
        type: ContentType;
        value: string;
      } | null;
    }>;
  } | null;
  institution?: {
    __typename: "Institution";
    id: string;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    items: Array<{
      __typename: "Page";
      type: PageType;
      order: number;
      slide?: {
        __typename: "Slide";
        contents?: {
          __typename: "ModelSlideContentConnection";
          items: Array<{
            __typename: "SlideContent";
            order: number;
            content?: {
              __typename: "Content";
              id: string;
              type: ContentType;
              value: string;
            } | null;
          }>;
        } | null;
        notes?: string | null;
      } | null;
      question?: {
        __typename: "Question";
        id: string;
        description?: string | null;
        value: string;
        type: QuestionType;
        choices?: {
          __typename: "ModelChoiceConnection";
          items: Array<{
            __typename: "Choice";
            id: string;
            value: string;
            order: number;
          }>;
        } | null;
        contents?: {
          __typename: "ModelQuestionContentConnection";
          items: Array<{
            __typename: "QuestionContent";
            order: number;
            content?: {
              __typename: "Content";
              id: string;
              type: ContentType;
              value: string;
            } | null;
          }>;
        } | null;
        answers?: {
          __typename: "ModelAnswerConnection";
          items: Array<{
            __typename: "Answer";
            correctness: number;
            default?: boolean | null;
            choices?: {
              __typename: "ModelAnswerChoiceConnection";
              items: Array<{
                __typename: "AnswerChoice";
                choice?: {
                  __typename: "Choice";
                  id: string;
                  order: number;
                } | null;
              }>;
            } | null;
            contents?: {
              __typename: "ModelAnswerContentConnection";
              items: Array<{
                __typename: "AnswerContent";
                order: number;
                content?: {
                  __typename: "Content";
                  id: string;
                  type: ContentType;
                  value: string;
                } | null;
              }>;
            } | null;
          }>;
        } | null;
        data?: string | null;
      } | null;
    }>;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    items: Array<{
      __typename: "Run";
      userID: string;
      responses?: {
        __typename: "ModelResponseConnection";
        items: Array<{
          __typename: "Response";
          id: string;
          correctness?: number | null;
          questionID: string;
          value?: string | null;
          choices?: {
            __typename: "ModelResponseChoiceConnection";
            items: Array<{
              __typename: "ResponseChoice";
              choiceID: string;
            }>;
          } | null;
        }>;
      } | null;
    }>;
  } | null;
};

export type getModuleForRunQuery = {
  __typename: "Module";
  id: string;
  active: boolean;
  visible?: boolean | null;
  public?: boolean | null;
  label: string;
  type: ModuleType;
  institution?: {
    __typename: "Institution";
    navigationNodeLevelNames?: Array<string | null> | null;
    navigationNodeConnections?: {
      __typename: "ModelNavigationNodeConnectionConnection";
      items: Array<{
        __typename: "NavigationNodeConnection";
        id: string;
        parent?: {
          __typename: "NavigationNode";
          id: string;
          label: string;
        } | null;
      }>;
    } | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    parentConnection?: {
      __typename: "NavigationNodeConnection";
      parent?: {
        __typename: "NavigationNode";
        id: string;
        label: string;
      } | null;
    } | null;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    items: Array<{
      __typename: "ModuleContent";
      order: number;
      content?: {
        __typename: "Content";
        type: ContentType;
        value: string;
      } | null;
    }>;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    items: Array<{
      __typename: "Page";
      id: string;
      type: PageType;
      order: number;
      question?: {
        __typename: "Question";
        id: string;
      } | null;
      slide?: {
        __typename: "Slide";
        contents?: {
          __typename: "ModelSlideContentConnection";
          items: Array<{
            __typename: "SlideContent";
            content?: {
              __typename: "Content";
              id: string;
              type: ContentType;
              value: string;
            } | null;
          }>;
        } | null;
      } | null;
    }>;
  } | null;
};

export type getUserForAdminQuery = {
  __typename: "User";
  institution?: {
    __typename: "Institution";
    modules?: {
      __typename: "ModelModuleConnection";
      items: Array<{
        __typename: "Module";
        id: string;
        type: ModuleType;
        label: string;
        order: number;
        questions?: {
          __typename: "ModelQuestionConnection";
          items: Array<{
            __typename: "Question";
            id: string;
            type: QuestionType;
            value: string;
            answers?: {
              __typename: "ModelAnswerConnection";
              items: Array<{
                __typename: "Answer";
                correctness: number;
                choices?: {
                  __typename: "ModelAnswerChoiceConnection";
                  items: Array<{
                    __typename: "AnswerChoice";
                    choice?: {
                      __typename: "Choice";
                      id: string;
                    } | null;
                  }>;
                } | null;
              }>;
            } | null;
            choices?: {
              __typename: "ModelChoiceConnection";
              items: Array<{
                __typename: "Choice";
                id: string;
                value: string;
                order: number;
              }>;
            } | null;
            data?: string | null;
            page?: {
              __typename: "Page";
              order: number;
            } | null;
          }>;
        } | null;
        runs?: {
          __typename: "ModelRunConnection";
          items: Array<{
            __typename: "Run";
            userID: string;
            responses?: {
              __typename: "ModelResponseConnection";
              items: Array<{
                __typename: "Response";
                id: string;
                correctness?: number | null;
                questionID: string;
                value?: string | null;
                choices?: {
                  __typename: "ModelResponseChoiceConnection";
                  items: Array<{
                    __typename: "ResponseChoice";
                    choiceID: string;
                  }>;
                } | null;
              }>;
            } | null;
          }>;
        } | null;
      }>;
      nextToken?: string | null;
    } | null;
  } | null;
};

export type GetInstitutionWithNodesQuery = {
  __typename: "Institution";
  id: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    items: Array<{
      __typename: "NavigationNode";
      id: string;
      active: boolean;
      visible?: boolean | null;
      description?: string | null;
      label: string;
      image: string;
      order?: number | null;
      parentConnection?: {
        __typename: "NavigationNodeConnection";
        id: string;
      } | null;
      childConnections?: {
        __typename: "ModelNavigationNodeConnectionConnection";
        items: Array<{
          __typename: "NavigationNodeConnection";
          child?: {
            __typename: "NavigationNode";
            active: boolean;
            visible?: boolean | null;
          } | null;
        }>;
      } | null;
      modules?: {
        __typename: "ModelModuleConnection";
        items: Array<{
          __typename: "Module";
          id: string;
          active: boolean;
          visible?: boolean | null;
        }>;
      } | null;
    }>;
  } | null;
};

export type CreateInstitutionMutation = {
  __typename: "Institution";
  id: string;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  navigationNodeConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
  users?: {
    __typename: "ModelUserConnection";
    nextToken?: string | null;
  } | null;
};

export type UpdateInstitutionMutation = {
  __typename: "Institution";
  id: string;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  navigationNodeConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
  users?: {
    __typename: "ModelUserConnection";
    nextToken?: string | null;
  } | null;
};

export type DeleteInstitutionMutation = {
  __typename: "Institution";
  id: string;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  navigationNodeConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
  users?: {
    __typename: "ModelUserConnection";
    nextToken?: string | null;
  } | null;
};

export type CreateAnswerMutation = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateAnswerMutation = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteAnswerMutation = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateAnswerChoiceMutation = {
  __typename: "AnswerChoice";
  id: string;
  choiceId: string;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateAnswerChoiceMutation = {
  __typename: "AnswerChoice";
  id: string;
  choiceId: string;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteAnswerChoiceMutation = {
  __typename: "AnswerChoice";
  id: string;
  choiceId: string;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateAnswerContentMutation = {
  __typename: "AnswerContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateAnswerContentMutation = {
  __typename: "AnswerContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteAnswerContentMutation = {
  __typename: "AnswerContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateChoiceMutation = {
  __typename: "Choice";
  id: string;
  value: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateChoiceMutation = {
  __typename: "Choice";
  id: string;
  value: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteChoiceMutation = {
  __typename: "Choice";
  id: string;
  value: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateContentMutation = {
  __typename: "Content";
  id: string;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  answers?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
  slides?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateContentMutation = {
  __typename: "Content";
  id: string;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  answers?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
  slides?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteContentMutation = {
  __typename: "Content";
  id: string;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  answers?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
  slides?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateModuleMutation = {
  __typename: "Module";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type UpdateModuleMutation = {
  __typename: "Module";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type DeleteModuleMutation = {
  __typename: "Module";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type CreateModuleContentMutation = {
  __typename: "ModuleContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateModuleContentMutation = {
  __typename: "ModuleContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteModuleContentMutation = {
  __typename: "ModuleContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateNavigationNodeMutation = {
  __typename: "NavigationNode";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  parentConnection?: {
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
};

export type UpdateNavigationNodeMutation = {
  __typename: "NavigationNode";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  parentConnection?: {
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
};

export type DeleteNavigationNodeMutation = {
  __typename: "NavigationNode";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  parentConnection?: {
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
};

export type CreateNavigationNodeConnectionMutation = {
  __typename: "NavigationNodeConnection";
  id: string;
  order: number;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  child?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  parent?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateNavigationNodeConnectionMutation = {
  __typename: "NavigationNodeConnection";
  id: string;
  order: number;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  child?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  parent?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteNavigationNodeConnectionMutation = {
  __typename: "NavigationNodeConnection";
  id: string;
  order: number;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  child?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  parent?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreatePageMutation = {
  __typename: "Page";
  id: string;
  order: number;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdatePageMutation = {
  __typename: "Page";
  id: string;
  order: number;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeletePageMutation = {
  __typename: "Page";
  id: string;
  order: number;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateQuestionMutation = {
  __typename: "Question";
  id: string;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  createdAt: string;
  updatedAt: string;
  answers?: {
    __typename: "ModelAnswerConnection";
    nextToken?: string | null;
  } | null;
  choices?: {
    __typename: "ModelChoiceConnection";
    nextToken?: string | null;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  page?: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
};

export type UpdateQuestionMutation = {
  __typename: "Question";
  id: string;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  createdAt: string;
  updatedAt: string;
  answers?: {
    __typename: "ModelAnswerConnection";
    nextToken?: string | null;
  } | null;
  choices?: {
    __typename: "ModelChoiceConnection";
    nextToken?: string | null;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  page?: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
};

export type DeleteQuestionMutation = {
  __typename: "Question";
  id: string;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  createdAt: string;
  updatedAt: string;
  answers?: {
    __typename: "ModelAnswerConnection";
    nextToken?: string | null;
  } | null;
  choices?: {
    __typename: "ModelChoiceConnection";
    nextToken?: string | null;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  page?: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
};

export type CreateQuestionContentMutation = {
  __typename: "QuestionContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateQuestionContentMutation = {
  __typename: "QuestionContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteQuestionContentMutation = {
  __typename: "QuestionContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateResponseMutation = {
  __typename: "Response";
  id: string;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelResponseChoiceConnection";
    nextToken?: string | null;
  } | null;
  run: {
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type UpdateResponseMutation = {
  __typename: "Response";
  id: string;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelResponseChoiceConnection";
    nextToken?: string | null;
  } | null;
  run: {
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type DeleteResponseMutation = {
  __typename: "Response";
  id: string;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelResponseChoiceConnection";
    nextToken?: string | null;
  } | null;
  run: {
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type CreateResponseChoiceMutation = {
  __typename: "ResponseChoice";
  id: string;
  responseID: string;
  choiceID: string;
  createdAt: string;
  updatedAt: string;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateResponseChoiceMutation = {
  __typename: "ResponseChoice";
  id: string;
  responseID: string;
  choiceID: string;
  createdAt: string;
  updatedAt: string;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteResponseChoiceMutation = {
  __typename: "ResponseChoice";
  id: string;
  responseID: string;
  choiceID: string;
  createdAt: string;
  updatedAt: string;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateRunMutation = {
  __typename: "Run";
  moduleID: string;
  userID: string;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateRunMutation = {
  __typename: "Run";
  moduleID: string;
  userID: string;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteRunMutation = {
  __typename: "Run";
  moduleID: string;
  userID: string;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateSlideMutation = {
  __typename: "Slide";
  pageID: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  page: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  };
  contents?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
};

export type UpdateSlideMutation = {
  __typename: "Slide";
  pageID: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  page: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  };
  contents?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
};

export type DeleteSlideMutation = {
  __typename: "Slide";
  pageID: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  page: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  };
  contents?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
};

export type CreateSlideContentMutation = {
  __typename: "SlideContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UpdateSlideContentMutation = {
  __typename: "SlideContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type DeleteSlideContentMutation = {
  __typename: "SlideContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type CreateUserMutation = {
  __typename: "User";
  id: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type UpdateUserMutation = {
  __typename: "User";
  id: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type DeleteUserMutation = {
  __typename: "User";
  id: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type CustomCreateResponseQuery = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GetInstitutionQuery = {
  __typename: "Institution";
  id: string;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  navigationNodeConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
  users?: {
    __typename: "ModelUserConnection";
    nextToken?: string | null;
  } | null;
};

export type ListInstitutionsQuery = {
  __typename: "ModelInstitutionConnection";
  items: Array<{
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetAnswerQuery = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAnswersQuery = {
  __typename: "ModelAnswerConnection";
  items: Array<{
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetAnswerChoiceQuery = {
  __typename: "AnswerChoice";
  id: string;
  choiceId: string;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAnswerChoicesQuery = {
  __typename: "ModelAnswerChoiceConnection";
  items: Array<{
    __typename: "AnswerChoice";
    id: string;
    choiceId: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetAnswerContentQuery = {
  __typename: "AnswerContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListAnswerContentsQuery = {
  __typename: "ModelAnswerContentConnection";
  items: Array<{
    __typename: "AnswerContent";
    id: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetChoiceQuery = {
  __typename: "Choice";
  id: string;
  value: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListChoicesQuery = {
  __typename: "ModelChoiceConnection";
  items: Array<{
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetContentQuery = {
  __typename: "Content";
  id: string;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  answers?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
  slides?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListContentsQuery = {
  __typename: "ModelContentConnection";
  items: Array<{
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type ContentsByUserCreatedAtQuery = {
  __typename: "ModelContentConnection";
  items: Array<{
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetModuleQuery = {
  __typename: "Module";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type ListModulesQuery = {
  __typename: "ModelModuleConnection";
  items: Array<{
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetModuleContentQuery = {
  __typename: "ModuleContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListModuleContentsQuery = {
  __typename: "ModelModuleContentConnection";
  items: Array<{
    __typename: "ModuleContent";
    id: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetNavigationNodeQuery = {
  __typename: "NavigationNode";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  parentConnection?: {
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
};

export type ListNavigationNodesQuery = {
  __typename: "ModelNavigationNodeConnection";
  items: Array<{
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetNavigationNodeConnectionQuery = {
  __typename: "NavigationNodeConnection";
  id: string;
  order: number;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  child?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  parent?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListNavigationNodeConnectionsQuery = {
  __typename: "ModelNavigationNodeConnectionConnection";
  items: Array<{
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetPageQuery = {
  __typename: "Page";
  id: string;
  order: number;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListPagesQuery = {
  __typename: "ModelPageConnection";
  items: Array<{
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetQuestionQuery = {
  __typename: "Question";
  id: string;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  createdAt: string;
  updatedAt: string;
  answers?: {
    __typename: "ModelAnswerConnection";
    nextToken?: string | null;
  } | null;
  choices?: {
    __typename: "ModelChoiceConnection";
    nextToken?: string | null;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  page?: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
};

export type ListQuestionsQuery = {
  __typename: "ModelQuestionConnection";
  items: Array<{
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetQuestionContentQuery = {
  __typename: "QuestionContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListQuestionContentsQuery = {
  __typename: "ModelQuestionContentConnection";
  items: Array<{
    __typename: "QuestionContent";
    id: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetResponseQuery = {
  __typename: "Response";
  id: string;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelResponseChoiceConnection";
    nextToken?: string | null;
  } | null;
  run: {
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type ListResponsesQuery = {
  __typename: "ModelResponseConnection";
  items: Array<{
    __typename: "Response";
    id: string;
    moduleID: string;
    questionID: string;
    userID: string;
    value?: string | null;
    correctness?: number | null;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetResponseChoiceQuery = {
  __typename: "ResponseChoice";
  id: string;
  responseID: string;
  choiceID: string;
  createdAt: string;
  updatedAt: string;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListResponseChoicesQuery = {
  __typename: "ModelResponseChoiceConnection";
  items: Array<{
    __typename: "ResponseChoice";
    id: string;
    responseID: string;
    choiceID: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetRunQuery = {
  __typename: "Run";
  moduleID: string;
  userID: string;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListRunsQuery = {
  __typename: "ModelRunConnection";
  items: Array<{
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetSlideQuery = {
  __typename: "Slide";
  pageID: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  page: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  };
  contents?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
};

export type ListSlidesQuery = {
  __typename: "ModelSlideConnection";
  items: Array<{
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetSlideContentQuery = {
  __typename: "SlideContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type ListSlideContentsQuery = {
  __typename: "ModelSlideContentConnection";
  items: Array<{
    __typename: "SlideContent";
    id: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type GetUserQuery = {
  __typename: "User";
  id: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type ListUsersQuery = {
  __typename: "ModelUserConnection";
  items: Array<{
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  }>;
  nextToken?: string | null;
};

export type OnCreateInstitutionSubscription = {
  __typename: "Institution";
  id: string;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  navigationNodeConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
  users?: {
    __typename: "ModelUserConnection";
    nextToken?: string | null;
  } | null;
};

export type OnUpdateInstitutionSubscription = {
  __typename: "Institution";
  id: string;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  navigationNodeConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
  users?: {
    __typename: "ModelUserConnection";
    nextToken?: string | null;
  } | null;
};

export type OnDeleteInstitutionSubscription = {
  __typename: "Institution";
  id: string;
  name: string;
  logo: string;
  navigationNodeLevelNames?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  navigationNodeConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
  users?: {
    __typename: "ModelUserConnection";
    nextToken?: string | null;
  } | null;
};

export type OnCreateAnswerSubscription = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateAnswerSubscription = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteAnswerSubscription = {
  __typename: "Answer";
  id: string;
  correctness: number;
  default?: boolean | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelAnswerChoiceConnection";
    nextToken?: string | null;
  } | null;
  contents?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateAnswerChoiceSubscription = {
  __typename: "AnswerChoice";
  id: string;
  choiceId: string;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateAnswerChoiceSubscription = {
  __typename: "AnswerChoice";
  id: string;
  choiceId: string;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteAnswerChoiceSubscription = {
  __typename: "AnswerChoice";
  id: string;
  choiceId: string;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateAnswerContentSubscription = {
  __typename: "AnswerContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateAnswerContentSubscription = {
  __typename: "AnswerContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteAnswerContentSubscription = {
  __typename: "AnswerContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  answer?: {
    __typename: "Answer";
    id: string;
    correctness: number;
    default?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateChoiceSubscription = {
  __typename: "Choice";
  id: string;
  value: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateChoiceSubscription = {
  __typename: "Choice";
  id: string;
  value: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteChoiceSubscription = {
  __typename: "Choice";
  id: string;
  value: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateContentSubscription = {
  __typename: "Content";
  id: string;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  answers?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
  slides?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateContentSubscription = {
  __typename: "Content";
  id: string;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  answers?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
  slides?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteContentSubscription = {
  __typename: "Content";
  id: string;
  type: ContentType;
  value: string;
  contentUserId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  answers?: {
    __typename: "ModelAnswerContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
  slides?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateModuleSubscription = {
  __typename: "Module";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type OnUpdateModuleSubscription = {
  __typename: "Module";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type OnDeleteModuleSubscription = {
  __typename: "Module";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  order: number;
  active: boolean;
  locked?: boolean | null;
  type: ModuleType;
  visible?: boolean | null;
  public?: boolean | null;
  ownerID: string;
  navigationNodeID: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelModuleContentConnection";
    nextToken?: string | null;
  } | null;
  navigationNode?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  pages?: {
    __typename: "ModelPageConnection";
    nextToken?: string | null;
  } | null;
  questions?: {
    __typename: "ModelQuestionConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type OnCreateModuleContentSubscription = {
  __typename: "ModuleContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateModuleContentSubscription = {
  __typename: "ModuleContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteModuleContentSubscription = {
  __typename: "ModuleContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateNavigationNodeSubscription = {
  __typename: "NavigationNode";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  parentConnection?: {
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
};

export type OnUpdateNavigationNodeSubscription = {
  __typename: "NavigationNode";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  parentConnection?: {
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
};

export type OnDeleteNavigationNodeSubscription = {
  __typename: "NavigationNode";
  id: string;
  label: string;
  image: string;
  description?: string | null;
  active: boolean;
  order?: number | null;
  visible?: boolean | null;
  ownerID: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  parentConnection?: {
    __typename: "NavigationNodeConnection";
    id: string;
    order: number;
    parentId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  childConnections?: {
    __typename: "ModelNavigationNodeConnectionConnection";
    nextToken?: string | null;
  } | null;
};

export type OnCreateNavigationNodeConnectionSubscription = {
  __typename: "NavigationNodeConnection";
  id: string;
  order: number;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  child?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  parent?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateNavigationNodeConnectionSubscription = {
  __typename: "NavigationNodeConnection";
  id: string;
  order: number;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  child?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  parent?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteNavigationNodeConnectionSubscription = {
  __typename: "NavigationNodeConnection";
  id: string;
  order: number;
  parentId: string;
  createdAt: string;
  updatedAt: string;
  institution: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  };
  child?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  parent?: {
    __typename: "NavigationNode";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    active: boolean;
    order?: number | null;
    visible?: boolean | null;
    ownerID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreatePageSubscription = {
  __typename: "Page";
  id: string;
  order: number;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdatePageSubscription = {
  __typename: "Page";
  id: string;
  order: number;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeletePageSubscription = {
  __typename: "Page";
  id: string;
  order: number;
  type: PageType;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateQuestionSubscription = {
  __typename: "Question";
  id: string;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  createdAt: string;
  updatedAt: string;
  answers?: {
    __typename: "ModelAnswerConnection";
    nextToken?: string | null;
  } | null;
  choices?: {
    __typename: "ModelChoiceConnection";
    nextToken?: string | null;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  page?: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
};

export type OnUpdateQuestionSubscription = {
  __typename: "Question";
  id: string;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  createdAt: string;
  updatedAt: string;
  answers?: {
    __typename: "ModelAnswerConnection";
    nextToken?: string | null;
  } | null;
  choices?: {
    __typename: "ModelChoiceConnection";
    nextToken?: string | null;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  page?: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
};

export type OnDeleteQuestionSubscription = {
  __typename: "Question";
  id: string;
  value: string;
  description?: string | null;
  type: QuestionType;
  data?: string | null;
  createdAt: string;
  updatedAt: string;
  answers?: {
    __typename: "ModelAnswerConnection";
    nextToken?: string | null;
  } | null;
  choices?: {
    __typename: "ModelChoiceConnection";
    nextToken?: string | null;
  } | null;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  page?: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelQuestionContentConnection";
    nextToken?: string | null;
  } | null;
};

export type OnCreateQuestionContentSubscription = {
  __typename: "QuestionContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateQuestionContentSubscription = {
  __typename: "QuestionContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteQuestionContentSubscription = {
  __typename: "QuestionContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  question?: {
    __typename: "Question";
    id: string;
    value: string;
    description?: string | null;
    type: QuestionType;
    data?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateResponseSubscription = {
  __typename: "Response";
  id: string;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelResponseChoiceConnection";
    nextToken?: string | null;
  } | null;
  run: {
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type OnUpdateResponseSubscription = {
  __typename: "Response";
  id: string;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelResponseChoiceConnection";
    nextToken?: string | null;
  } | null;
  run: {
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type OnDeleteResponseSubscription = {
  __typename: "Response";
  id: string;
  moduleID: string;
  questionID: string;
  userID: string;
  value?: string | null;
  correctness?: number | null;
  createdAt: string;
  updatedAt: string;
  choices?: {
    __typename: "ModelResponseChoiceConnection";
    nextToken?: string | null;
  } | null;
  run: {
    __typename: "Run";
    moduleID: string;
    userID: string;
    createdAt: string;
    updatedAt: string;
  };
  user: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  };
};

export type OnCreateResponseChoiceSubscription = {
  __typename: "ResponseChoice";
  id: string;
  responseID: string;
  choiceID: string;
  createdAt: string;
  updatedAt: string;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateResponseChoiceSubscription = {
  __typename: "ResponseChoice";
  id: string;
  responseID: string;
  choiceID: string;
  createdAt: string;
  updatedAt: string;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteResponseChoiceSubscription = {
  __typename: "ResponseChoice";
  id: string;
  responseID: string;
  choiceID: string;
  createdAt: string;
  updatedAt: string;
  choice?: {
    __typename: "Choice";
    id: string;
    value: string;
    order: number;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateRunSubscription = {
  __typename: "Run";
  moduleID: string;
  userID: string;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateRunSubscription = {
  __typename: "Run";
  moduleID: string;
  userID: string;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteRunSubscription = {
  __typename: "Run";
  moduleID: string;
  userID: string;
  createdAt: string;
  updatedAt: string;
  module?: {
    __typename: "Module";
    id: string;
    label: string;
    image: string;
    description?: string | null;
    order: number;
    active: boolean;
    locked?: boolean | null;
    type: ModuleType;
    visible?: boolean | null;
    public?: boolean | null;
    ownerID: string;
    navigationNodeID: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  user?: {
    __typename: "User";
    id: string;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateSlideSubscription = {
  __typename: "Slide";
  pageID: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  page: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  };
  contents?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
};

export type OnUpdateSlideSubscription = {
  __typename: "Slide";
  pageID: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  page: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  };
  contents?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
};

export type OnDeleteSlideSubscription = {
  __typename: "Slide";
  pageID: string;
  notes?: string | null;
  createdAt: string;
  updatedAt: string;
  page: {
    __typename: "Page";
    id: string;
    order: number;
    type: PageType;
    createdAt: string;
    updatedAt: string;
  };
  contents?: {
    __typename: "ModelSlideContentConnection";
    nextToken?: string | null;
  } | null;
};

export type OnCreateSlideContentSubscription = {
  __typename: "SlideContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnUpdateSlideContentSubscription = {
  __typename: "SlideContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnDeleteSlideContentSubscription = {
  __typename: "SlideContent";
  id: string;
  order: number;
  createdAt: string;
  updatedAt: string;
  content?: {
    __typename: "Content";
    id: string;
    type: ContentType;
    value: string;
    contentUserId: string;
    createdAt: string;
    updatedAt: string;
  } | null;
  slide?: {
    __typename: "Slide";
    pageID: string;
    notes?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OnCreateUserSubscription = {
  __typename: "User";
  id: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type OnUpdateUserSubscription = {
  __typename: "User";
  id: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

export type OnDeleteUserSubscription = {
  __typename: "User";
  id: string;
  createdAt: string;
  updatedAt: string;
  institution?: {
    __typename: "Institution";
    id: string;
    name: string;
    logo: string;
    navigationNodeLevelNames?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  contents?: {
    __typename: "ModelContentConnection";
    nextToken?: string | null;
  } | null;
  modules?: {
    __typename: "ModelModuleConnection";
    nextToken?: string | null;
  } | null;
  navigationNodes?: {
    __typename: "ModelNavigationNodeConnection";
    nextToken?: string | null;
  } | null;
  responses?: {
    __typename: "ModelResponseConnection";
    nextToken?: string | null;
  } | null;
  runs?: {
    __typename: "ModelRunConnection";
    nextToken?: string | null;
  } | null;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async getNavigationNodeForUser(
    navigationNodeId: string,
    userID: string
  ): Promise<getNavigationNodeForUserQuery> {
    const statement = `query getNavigationNodeForUser($navigationNodeId: ID!, $userID: ID!) {
        getNavigationNode(id: $navigationNodeId) {
          __typename
          active
          childConnections {
            __typename
            items {
              __typename
              order
              child {
                __typename
                active
                description
                id
                image
                label
                childConnections {
                  __typename
                  items {
                    __typename
                    child {
                      __typename
                      active
                      visible
                    }
                  }
                }
                modules(filter: {active: {eq: true}, ownerID: {eq: $userID}}) {
                  __typename
                  items {
                    __typename
                    id
                    visible
                  }
                }
                visible
              }
            }
            nextToken
          }
          description
          id
          institution {
            __typename
            id
            navigationNodeLevelNames
            navigationNodeConnections {
              __typename
              items {
                __typename
                id
                parentId
              }
            }
            navigationNodes(filter: {ownerID: {eq: $userID}}) {
              __typename
              items {
                __typename
                id
                label
              }
            }
          }
          label
          modules(filter: {active: {eq: true}, ownerID: {eq: $userID}}) {
            __typename
            items {
              __typename
              active
              description
              id
              image
              label
              order
              visible
              public
              questions {
                __typename
                items {
                  __typename
                  id
                }
              }
              runs(userID: {eq: $userID}) {
                __typename
                items {
                  __typename
                  responses {
                    __typename
                    items {
                      __typename
                      id
                      questionID
                    }
                  }
                }
              }
              type
            }
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      navigationNodeId,
      userID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <getNavigationNodeForUserQuery>response.data.getNavigationNode;
  }
  async getModuleForAdmin(moduleId: string): Promise<getModuleForAdminQuery> {
    const statement = `query getModuleForAdmin($moduleId: ID!) {
        getModule(id: $moduleId) {
          __typename
          id
          description
          order
          image
          label
          type
          active
          visible
          locked
          contents {
            __typename
            items {
              __typename
              order
              content {
                __typename
                id
                type
                value
              }
            }
          }
          institution {
            __typename
            id
          }
          navigationNode {
            __typename
            id
          }
          pages {
            __typename
            items {
              __typename
              type
              order
              slide {
                __typename
                contents {
                  __typename
                  items {
                    __typename
                    order
                    content {
                      __typename
                      id
                      type
                      value
                    }
                  }
                }
                notes
              }
              question {
                __typename
                id
                description
                value
                type
                choices {
                  __typename
                  items {
                    __typename
                    id
                    value
                    order
                  }
                }
                contents {
                  __typename
                  items {
                    __typename
                    order
                    content {
                      __typename
                      id
                      type
                      value
                    }
                  }
                }
                answers {
                  __typename
                  items {
                    __typename
                    correctness
                    default
                    choices {
                      __typename
                      items {
                        __typename
                        choice {
                          __typename
                          id
                          order
                        }
                      }
                    }
                    contents {
                      __typename
                      items {
                        __typename
                        order
                        content {
                          __typename
                          id
                          type
                          value
                        }
                      }
                    }
                  }
                }
                data
              }
            }
          }
          runs {
            __typename
            items {
              __typename
              userID
              responses(sortDirection: DESC) {
                __typename
                items {
                  __typename
                  id
                  correctness
                  questionID
                  value
                  choices {
                    __typename
                    items {
                      __typename
                      choiceID
                    }
                  }
                }
              }
            }
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      moduleId
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <getModuleForAdminQuery>response.data.getModule;
  }
  async getModuleForRun(moduleID: string): Promise<getModuleForRunQuery> {
    const statement = `query getModuleForRun($moduleID: ID!) {
        getModule(id: $moduleID) {
          __typename
          id
          active
          visible
          public
          label
          type
          institution {
            __typename
            navigationNodeLevelNames
            navigationNodeConnections {
              __typename
              items {
                __typename
                id
                parent {
                  __typename
                  id
                  label
                }
              }
            }
          }
          navigationNode {
            __typename
            id
            label
            parentConnection {
              __typename
              parent {
                __typename
                id
                label
              }
            }
          }
          contents {
            __typename
            items {
              __typename
              order
              content {
                __typename
                type
                value
              }
            }
          }
          pages {
            __typename
            items {
              __typename
              id
              type
              order
              question {
                __typename
                id
              }
              slide {
                __typename
                contents {
                  __typename
                  items {
                    __typename
                    content {
                      __typename
                      id
                      type
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      moduleID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <getModuleForRunQuery>response.data.getModule;
  }
  async getUserForAdmin(
    userID: string,
    modulesNextToken?: string
  ): Promise<getUserForAdminQuery> {
    const statement = `query getUserForAdmin($userID: ID!, $modulesNextToken: String) {
        getUser(id: $userID) {
          __typename
          institution {
            __typename
            modules(filter: {active: {eq: true}}, nextToken: $modulesNextToken) {
              __typename
              items {
                __typename
                id
                type
                label
                order
                questions {
                  __typename
                  items {
                    __typename
                    id
                    type
                    value
                    answers {
                      __typename
                      items {
                        __typename
                        correctness
                        choices {
                          __typename
                          items {
                            __typename
                            choice {
                              __typename
                              id
                            }
                          }
                        }
                      }
                    }
                    choices {
                      __typename
                      items {
                        __typename
                        id
                        value
                        order
                      }
                    }
                    data
                    page {
                      __typename
                      order
                    }
                  }
                }
                runs(userID: {eq: $userID}) {
                  __typename
                  items {
                    __typename
                    userID
                    responses {
                      __typename
                      items {
                        __typename
                        id
                        correctness
                        questionID
                        value
                        choices {
                          __typename
                          items {
                            __typename
                            choiceID
                          }
                        }
                      }
                    }
                  }
                }
              }
              nextToken
            }
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userID
    };
    if (modulesNextToken) {
      gqlAPIServiceArguments.modulesNextToken = modulesNextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <getUserForAdminQuery>response.data.getUser;
  }
  async GetInstitutionWithNodes(
    institutionId: string,
    ownerID: string
  ): Promise<GetInstitutionWithNodesQuery> {
    const statement = `query GetInstitutionWithNodes($institutionId: ID!, $ownerID: ID!) {
        getInstitution(id: $institutionId) {
          __typename
          id
          navigationNodeLevelNames
          navigationNodes(filter: {active: {eq: true}, ownerID: {eq: $ownerID}}) {
            __typename
            items {
              __typename
              id
              active
              visible
              description
              label
              image
              order
              parentConnection {
                __typename
                id
              }
              childConnections {
                __typename
                items {
                  __typename
                  child {
                    __typename
                    active
                    visible
                  }
                }
              }
              modules(filter: {active: {eq: true}, ownerID: {eq: $ownerID}}) {
                __typename
                items {
                  __typename
                  id
                  active
                  visible
                }
              }
            }
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      institutionId,
      ownerID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetInstitutionWithNodesQuery>response.data.getInstitution;
  }
  async CreateInstitution(
    input: CreateInstitutionInput,
    condition?: ModelInstitutionConditionInput
  ): Promise<CreateInstitutionMutation> {
    const statement = `mutation CreateInstitution($input: CreateInstitutionInput!, $condition: ModelInstitutionConditionInput) {
        createInstitution(input: $input, condition: $condition) {
          __typename
          id
          name
          logo
          navigationNodeLevelNames
          createdAt
          updatedAt
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          navigationNodeConnections {
            __typename
            nextToken
          }
          users {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateInstitutionMutation>response.data.createInstitution;
  }
  async UpdateInstitution(
    input: UpdateInstitutionInput,
    condition?: ModelInstitutionConditionInput
  ): Promise<UpdateInstitutionMutation> {
    const statement = `mutation UpdateInstitution($input: UpdateInstitutionInput!, $condition: ModelInstitutionConditionInput) {
        updateInstitution(input: $input, condition: $condition) {
          __typename
          id
          name
          logo
          navigationNodeLevelNames
          createdAt
          updatedAt
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          navigationNodeConnections {
            __typename
            nextToken
          }
          users {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateInstitutionMutation>response.data.updateInstitution;
  }
  async DeleteInstitution(
    input: DeleteInstitutionInput,
    condition?: ModelInstitutionConditionInput
  ): Promise<DeleteInstitutionMutation> {
    const statement = `mutation DeleteInstitution($input: DeleteInstitutionInput!, $condition: ModelInstitutionConditionInput) {
        deleteInstitution(input: $input, condition: $condition) {
          __typename
          id
          name
          logo
          navigationNodeLevelNames
          createdAt
          updatedAt
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          navigationNodeConnections {
            __typename
            nextToken
          }
          users {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteInstitutionMutation>response.data.deleteInstitution;
  }
  async CreateAnswer(
    input: CreateAnswerInput,
    condition?: ModelAnswerConditionInput
  ): Promise<CreateAnswerMutation> {
    const statement = `mutation CreateAnswer($input: CreateAnswerInput!, $condition: ModelAnswerConditionInput) {
        createAnswer(input: $input, condition: $condition) {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateAnswerMutation>response.data.createAnswer;
  }
  async UpdateAnswer(
    input: UpdateAnswerInput,
    condition?: ModelAnswerConditionInput
  ): Promise<UpdateAnswerMutation> {
    const statement = `mutation UpdateAnswer($input: UpdateAnswerInput!, $condition: ModelAnswerConditionInput) {
        updateAnswer(input: $input, condition: $condition) {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateAnswerMutation>response.data.updateAnswer;
  }
  async DeleteAnswer(
    input: DeleteAnswerInput,
    condition?: ModelAnswerConditionInput
  ): Promise<DeleteAnswerMutation> {
    const statement = `mutation DeleteAnswer($input: DeleteAnswerInput!, $condition: ModelAnswerConditionInput) {
        deleteAnswer(input: $input, condition: $condition) {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteAnswerMutation>response.data.deleteAnswer;
  }
  async CreateAnswerChoice(
    input: CreateAnswerChoiceInput,
    condition?: ModelAnswerChoiceConditionInput
  ): Promise<CreateAnswerChoiceMutation> {
    const statement = `mutation CreateAnswerChoice($input: CreateAnswerChoiceInput!, $condition: ModelAnswerChoiceConditionInput) {
        createAnswerChoice(input: $input, condition: $condition) {
          __typename
          id
          choiceId
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateAnswerChoiceMutation>response.data.createAnswerChoice;
  }
  async UpdateAnswerChoice(
    input: UpdateAnswerChoiceInput,
    condition?: ModelAnswerChoiceConditionInput
  ): Promise<UpdateAnswerChoiceMutation> {
    const statement = `mutation UpdateAnswerChoice($input: UpdateAnswerChoiceInput!, $condition: ModelAnswerChoiceConditionInput) {
        updateAnswerChoice(input: $input, condition: $condition) {
          __typename
          id
          choiceId
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateAnswerChoiceMutation>response.data.updateAnswerChoice;
  }
  async DeleteAnswerChoice(
    input: DeleteAnswerChoiceInput,
    condition?: ModelAnswerChoiceConditionInput
  ): Promise<DeleteAnswerChoiceMutation> {
    const statement = `mutation DeleteAnswerChoice($input: DeleteAnswerChoiceInput!, $condition: ModelAnswerChoiceConditionInput) {
        deleteAnswerChoice(input: $input, condition: $condition) {
          __typename
          id
          choiceId
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteAnswerChoiceMutation>response.data.deleteAnswerChoice;
  }
  async CreateAnswerContent(
    input: CreateAnswerContentInput,
    condition?: ModelAnswerContentConditionInput
  ): Promise<CreateAnswerContentMutation> {
    const statement = `mutation CreateAnswerContent($input: CreateAnswerContentInput!, $condition: ModelAnswerContentConditionInput) {
        createAnswerContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateAnswerContentMutation>response.data.createAnswerContent;
  }
  async UpdateAnswerContent(
    input: UpdateAnswerContentInput,
    condition?: ModelAnswerContentConditionInput
  ): Promise<UpdateAnswerContentMutation> {
    const statement = `mutation UpdateAnswerContent($input: UpdateAnswerContentInput!, $condition: ModelAnswerContentConditionInput) {
        updateAnswerContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateAnswerContentMutation>response.data.updateAnswerContent;
  }
  async DeleteAnswerContent(
    input: DeleteAnswerContentInput,
    condition?: ModelAnswerContentConditionInput
  ): Promise<DeleteAnswerContentMutation> {
    const statement = `mutation DeleteAnswerContent($input: DeleteAnswerContentInput!, $condition: ModelAnswerContentConditionInput) {
        deleteAnswerContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteAnswerContentMutation>response.data.deleteAnswerContent;
  }
  async CreateChoice(
    input: CreateChoiceInput,
    condition?: ModelChoiceConditionInput
  ): Promise<CreateChoiceMutation> {
    const statement = `mutation CreateChoice($input: CreateChoiceInput!, $condition: ModelChoiceConditionInput) {
        createChoice(input: $input, condition: $condition) {
          __typename
          id
          value
          order
          createdAt
          updatedAt
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateChoiceMutation>response.data.createChoice;
  }
  async UpdateChoice(
    input: UpdateChoiceInput,
    condition?: ModelChoiceConditionInput
  ): Promise<UpdateChoiceMutation> {
    const statement = `mutation UpdateChoice($input: UpdateChoiceInput!, $condition: ModelChoiceConditionInput) {
        updateChoice(input: $input, condition: $condition) {
          __typename
          id
          value
          order
          createdAt
          updatedAt
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateChoiceMutation>response.data.updateChoice;
  }
  async DeleteChoice(
    input: DeleteChoiceInput,
    condition?: ModelChoiceConditionInput
  ): Promise<DeleteChoiceMutation> {
    const statement = `mutation DeleteChoice($input: DeleteChoiceInput!, $condition: ModelChoiceConditionInput) {
        deleteChoice(input: $input, condition: $condition) {
          __typename
          id
          value
          order
          createdAt
          updatedAt
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteChoiceMutation>response.data.deleteChoice;
  }
  async CreateContent(
    input: CreateContentInput,
    condition?: ModelContentConditionInput
  ): Promise<CreateContentMutation> {
    const statement = `mutation CreateContent($input: CreateContentInput!, $condition: ModelContentConditionInput) {
        createContent(input: $input, condition: $condition) {
          __typename
          id
          type
          value
          contentUserId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          answers {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          slides {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateContentMutation>response.data.createContent;
  }
  async UpdateContent(
    input: UpdateContentInput,
    condition?: ModelContentConditionInput
  ): Promise<UpdateContentMutation> {
    const statement = `mutation UpdateContent($input: UpdateContentInput!, $condition: ModelContentConditionInput) {
        updateContent(input: $input, condition: $condition) {
          __typename
          id
          type
          value
          contentUserId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          answers {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          slides {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateContentMutation>response.data.updateContent;
  }
  async DeleteContent(
    input: DeleteContentInput,
    condition?: ModelContentConditionInput
  ): Promise<DeleteContentMutation> {
    const statement = `mutation DeleteContent($input: DeleteContentInput!, $condition: ModelContentConditionInput) {
        deleteContent(input: $input, condition: $condition) {
          __typename
          id
          type
          value
          contentUserId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          answers {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          slides {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteContentMutation>response.data.deleteContent;
  }
  async CreateModule(
    input: CreateModuleInput,
    condition?: ModelModuleConditionInput
  ): Promise<CreateModuleMutation> {
    const statement = `mutation CreateModule($input: CreateModuleInput!, $condition: ModelModuleConditionInput) {
        createModule(input: $input, condition: $condition) {
          __typename
          id
          label
          image
          description
          order
          active
          locked
          type
          visible
          public
          ownerID
          navigationNodeID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          navigationNode {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          pages {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateModuleMutation>response.data.createModule;
  }
  async UpdateModule(
    input: UpdateModuleInput,
    condition?: ModelModuleConditionInput
  ): Promise<UpdateModuleMutation> {
    const statement = `mutation UpdateModule($input: UpdateModuleInput!, $condition: ModelModuleConditionInput) {
        updateModule(input: $input, condition: $condition) {
          __typename
          id
          label
          image
          description
          order
          active
          locked
          type
          visible
          public
          ownerID
          navigationNodeID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          navigationNode {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          pages {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateModuleMutation>response.data.updateModule;
  }
  async DeleteModule(
    input: DeleteModuleInput,
    condition?: ModelModuleConditionInput
  ): Promise<DeleteModuleMutation> {
    const statement = `mutation DeleteModule($input: DeleteModuleInput!, $condition: ModelModuleConditionInput) {
        deleteModule(input: $input, condition: $condition) {
          __typename
          id
          label
          image
          description
          order
          active
          locked
          type
          visible
          public
          ownerID
          navigationNodeID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          navigationNode {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          pages {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteModuleMutation>response.data.deleteModule;
  }
  async CreateModuleContent(
    input: CreateModuleContentInput,
    condition?: ModelModuleContentConditionInput
  ): Promise<CreateModuleContentMutation> {
    const statement = `mutation CreateModuleContent($input: CreateModuleContentInput!, $condition: ModelModuleContentConditionInput) {
        createModuleContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateModuleContentMutation>response.data.createModuleContent;
  }
  async UpdateModuleContent(
    input: UpdateModuleContentInput,
    condition?: ModelModuleContentConditionInput
  ): Promise<UpdateModuleContentMutation> {
    const statement = `mutation UpdateModuleContent($input: UpdateModuleContentInput!, $condition: ModelModuleContentConditionInput) {
        updateModuleContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateModuleContentMutation>response.data.updateModuleContent;
  }
  async DeleteModuleContent(
    input: DeleteModuleContentInput,
    condition?: ModelModuleContentConditionInput
  ): Promise<DeleteModuleContentMutation> {
    const statement = `mutation DeleteModuleContent($input: DeleteModuleContentInput!, $condition: ModelModuleContentConditionInput) {
        deleteModuleContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteModuleContentMutation>response.data.deleteModuleContent;
  }
  async CreateNavigationNode(
    input: CreateNavigationNodeInput,
    condition?: ModelNavigationNodeConditionInput
  ): Promise<CreateNavigationNodeMutation> {
    const statement = `mutation CreateNavigationNode($input: CreateNavigationNodeInput!, $condition: ModelNavigationNodeConditionInput) {
        createNavigationNode(input: $input, condition: $condition) {
          __typename
          id
          label
          image
          description
          active
          order
          visible
          ownerID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          modules {
            __typename
            nextToken
          }
          parentConnection {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          childConnections {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNavigationNodeMutation>response.data.createNavigationNode;
  }
  async UpdateNavigationNode(
    input: UpdateNavigationNodeInput,
    condition?: ModelNavigationNodeConditionInput
  ): Promise<UpdateNavigationNodeMutation> {
    const statement = `mutation UpdateNavigationNode($input: UpdateNavigationNodeInput!, $condition: ModelNavigationNodeConditionInput) {
        updateNavigationNode(input: $input, condition: $condition) {
          __typename
          id
          label
          image
          description
          active
          order
          visible
          ownerID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          modules {
            __typename
            nextToken
          }
          parentConnection {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          childConnections {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNavigationNodeMutation>response.data.updateNavigationNode;
  }
  async DeleteNavigationNode(
    input: DeleteNavigationNodeInput,
    condition?: ModelNavigationNodeConditionInput
  ): Promise<DeleteNavigationNodeMutation> {
    const statement = `mutation DeleteNavigationNode($input: DeleteNavigationNodeInput!, $condition: ModelNavigationNodeConditionInput) {
        deleteNavigationNode(input: $input, condition: $condition) {
          __typename
          id
          label
          image
          description
          active
          order
          visible
          ownerID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          modules {
            __typename
            nextToken
          }
          parentConnection {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          childConnections {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNavigationNodeMutation>response.data.deleteNavigationNode;
  }
  async CreateNavigationNodeConnection(
    input: CreateNavigationNodeConnectionInput,
    condition?: ModelNavigationNodeConnectionConditionInput
  ): Promise<CreateNavigationNodeConnectionMutation> {
    const statement = `mutation CreateNavigationNodeConnection($input: CreateNavigationNodeConnectionInput!, $condition: ModelNavigationNodeConnectionConditionInput) {
        createNavigationNodeConnection(input: $input, condition: $condition) {
          __typename
          id
          order
          parentId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          child {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          parent {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNavigationNodeConnectionMutation>(
      response.data.createNavigationNodeConnection
    );
  }
  async UpdateNavigationNodeConnection(
    input: UpdateNavigationNodeConnectionInput,
    condition?: ModelNavigationNodeConnectionConditionInput
  ): Promise<UpdateNavigationNodeConnectionMutation> {
    const statement = `mutation UpdateNavigationNodeConnection($input: UpdateNavigationNodeConnectionInput!, $condition: ModelNavigationNodeConnectionConditionInput) {
        updateNavigationNodeConnection(input: $input, condition: $condition) {
          __typename
          id
          order
          parentId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          child {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          parent {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNavigationNodeConnectionMutation>(
      response.data.updateNavigationNodeConnection
    );
  }
  async DeleteNavigationNodeConnection(
    input: DeleteNavigationNodeConnectionInput,
    condition?: ModelNavigationNodeConnectionConditionInput
  ): Promise<DeleteNavigationNodeConnectionMutation> {
    const statement = `mutation DeleteNavigationNodeConnection($input: DeleteNavigationNodeConnectionInput!, $condition: ModelNavigationNodeConnectionConditionInput) {
        deleteNavigationNodeConnection(input: $input, condition: $condition) {
          __typename
          id
          order
          parentId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          child {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          parent {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNavigationNodeConnectionMutation>(
      response.data.deleteNavigationNodeConnection
    );
  }
  async CreatePage(
    input: CreatePageInput,
    condition?: ModelPageConditionInput
  ): Promise<CreatePageMutation> {
    const statement = `mutation CreatePage($input: CreatePageInput!, $condition: ModelPageConditionInput) {
        createPage(input: $input, condition: $condition) {
          __typename
          id
          order
          type
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePageMutation>response.data.createPage;
  }
  async UpdatePage(
    input: UpdatePageInput,
    condition?: ModelPageConditionInput
  ): Promise<UpdatePageMutation> {
    const statement = `mutation UpdatePage($input: UpdatePageInput!, $condition: ModelPageConditionInput) {
        updatePage(input: $input, condition: $condition) {
          __typename
          id
          order
          type
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePageMutation>response.data.updatePage;
  }
  async DeletePage(
    input: DeletePageInput,
    condition?: ModelPageConditionInput
  ): Promise<DeletePageMutation> {
    const statement = `mutation DeletePage($input: DeletePageInput!, $condition: ModelPageConditionInput) {
        deletePage(input: $input, condition: $condition) {
          __typename
          id
          order
          type
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePageMutation>response.data.deletePage;
  }
  async CreateQuestion(
    input: CreateQuestionInput,
    condition?: ModelQuestionConditionInput
  ): Promise<CreateQuestionMutation> {
    const statement = `mutation CreateQuestion($input: CreateQuestionInput!, $condition: ModelQuestionConditionInput) {
        createQuestion(input: $input, condition: $condition) {
          __typename
          id
          value
          description
          type
          data
          createdAt
          updatedAt
          answers {
            __typename
            nextToken
          }
          choices {
            __typename
            nextToken
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateQuestionMutation>response.data.createQuestion;
  }
  async UpdateQuestion(
    input: UpdateQuestionInput,
    condition?: ModelQuestionConditionInput
  ): Promise<UpdateQuestionMutation> {
    const statement = `mutation UpdateQuestion($input: UpdateQuestionInput!, $condition: ModelQuestionConditionInput) {
        updateQuestion(input: $input, condition: $condition) {
          __typename
          id
          value
          description
          type
          data
          createdAt
          updatedAt
          answers {
            __typename
            nextToken
          }
          choices {
            __typename
            nextToken
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateQuestionMutation>response.data.updateQuestion;
  }
  async DeleteQuestion(
    input: DeleteQuestionInput,
    condition?: ModelQuestionConditionInput
  ): Promise<DeleteQuestionMutation> {
    const statement = `mutation DeleteQuestion($input: DeleteQuestionInput!, $condition: ModelQuestionConditionInput) {
        deleteQuestion(input: $input, condition: $condition) {
          __typename
          id
          value
          description
          type
          data
          createdAt
          updatedAt
          answers {
            __typename
            nextToken
          }
          choices {
            __typename
            nextToken
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteQuestionMutation>response.data.deleteQuestion;
  }
  async CreateQuestionContent(
    input: CreateQuestionContentInput,
    condition?: ModelQuestionContentConditionInput
  ): Promise<CreateQuestionContentMutation> {
    const statement = `mutation CreateQuestionContent($input: CreateQuestionContentInput!, $condition: ModelQuestionContentConditionInput) {
        createQuestionContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateQuestionContentMutation>response.data.createQuestionContent;
  }
  async UpdateQuestionContent(
    input: UpdateQuestionContentInput,
    condition?: ModelQuestionContentConditionInput
  ): Promise<UpdateQuestionContentMutation> {
    const statement = `mutation UpdateQuestionContent($input: UpdateQuestionContentInput!, $condition: ModelQuestionContentConditionInput) {
        updateQuestionContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateQuestionContentMutation>response.data.updateQuestionContent;
  }
  async DeleteQuestionContent(
    input: DeleteQuestionContentInput,
    condition?: ModelQuestionContentConditionInput
  ): Promise<DeleteQuestionContentMutation> {
    const statement = `mutation DeleteQuestionContent($input: DeleteQuestionContentInput!, $condition: ModelQuestionContentConditionInput) {
        deleteQuestionContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteQuestionContentMutation>response.data.deleteQuestionContent;
  }
  async CreateResponse(
    input: CreateResponseInput,
    condition?: ModelResponseConditionInput
  ): Promise<CreateResponseMutation> {
    const statement = `mutation CreateResponse($input: CreateResponseInput!, $condition: ModelResponseConditionInput) {
        createResponse(input: $input, condition: $condition) {
          __typename
          id
          moduleID
          questionID
          userID
          value
          correctness
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          run {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateResponseMutation>response.data.createResponse;
  }
  async UpdateResponse(
    input: UpdateResponseInput,
    condition?: ModelResponseConditionInput
  ): Promise<UpdateResponseMutation> {
    const statement = `mutation UpdateResponse($input: UpdateResponseInput!, $condition: ModelResponseConditionInput) {
        updateResponse(input: $input, condition: $condition) {
          __typename
          id
          moduleID
          questionID
          userID
          value
          correctness
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          run {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateResponseMutation>response.data.updateResponse;
  }
  async DeleteResponse(
    input: DeleteResponseInput,
    condition?: ModelResponseConditionInput
  ): Promise<DeleteResponseMutation> {
    const statement = `mutation DeleteResponse($input: DeleteResponseInput!, $condition: ModelResponseConditionInput) {
        deleteResponse(input: $input, condition: $condition) {
          __typename
          id
          moduleID
          questionID
          userID
          value
          correctness
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          run {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteResponseMutation>response.data.deleteResponse;
  }
  async CreateResponseChoice(
    input: CreateResponseChoiceInput,
    condition?: ModelResponseChoiceConditionInput
  ): Promise<CreateResponseChoiceMutation> {
    const statement = `mutation CreateResponseChoice($input: CreateResponseChoiceInput!, $condition: ModelResponseChoiceConditionInput) {
        createResponseChoice(input: $input, condition: $condition) {
          __typename
          id
          responseID
          choiceID
          createdAt
          updatedAt
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateResponseChoiceMutation>response.data.createResponseChoice;
  }
  async UpdateResponseChoice(
    input: UpdateResponseChoiceInput,
    condition?: ModelResponseChoiceConditionInput
  ): Promise<UpdateResponseChoiceMutation> {
    const statement = `mutation UpdateResponseChoice($input: UpdateResponseChoiceInput!, $condition: ModelResponseChoiceConditionInput) {
        updateResponseChoice(input: $input, condition: $condition) {
          __typename
          id
          responseID
          choiceID
          createdAt
          updatedAt
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateResponseChoiceMutation>response.data.updateResponseChoice;
  }
  async DeleteResponseChoice(
    input: DeleteResponseChoiceInput,
    condition?: ModelResponseChoiceConditionInput
  ): Promise<DeleteResponseChoiceMutation> {
    const statement = `mutation DeleteResponseChoice($input: DeleteResponseChoiceInput!, $condition: ModelResponseChoiceConditionInput) {
        deleteResponseChoice(input: $input, condition: $condition) {
          __typename
          id
          responseID
          choiceID
          createdAt
          updatedAt
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteResponseChoiceMutation>response.data.deleteResponseChoice;
  }
  async CreateRun(
    input: CreateRunInput,
    condition?: ModelRunConditionInput
  ): Promise<CreateRunMutation> {
    const statement = `mutation CreateRun($input: CreateRunInput!, $condition: ModelRunConditionInput) {
        createRun(input: $input, condition: $condition) {
          __typename
          moduleID
          userID
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          responses {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateRunMutation>response.data.createRun;
  }
  async UpdateRun(
    input: UpdateRunInput,
    condition?: ModelRunConditionInput
  ): Promise<UpdateRunMutation> {
    const statement = `mutation UpdateRun($input: UpdateRunInput!, $condition: ModelRunConditionInput) {
        updateRun(input: $input, condition: $condition) {
          __typename
          moduleID
          userID
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          responses {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateRunMutation>response.data.updateRun;
  }
  async DeleteRun(
    input: DeleteRunInput,
    condition?: ModelRunConditionInput
  ): Promise<DeleteRunMutation> {
    const statement = `mutation DeleteRun($input: DeleteRunInput!, $condition: ModelRunConditionInput) {
        deleteRun(input: $input, condition: $condition) {
          __typename
          moduleID
          userID
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          responses {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteRunMutation>response.data.deleteRun;
  }
  async CreateSlide(
    input: CreateSlideInput,
    condition?: ModelSlideConditionInput
  ): Promise<CreateSlideMutation> {
    const statement = `mutation CreateSlide($input: CreateSlideInput!, $condition: ModelSlideConditionInput) {
        createSlide(input: $input, condition: $condition) {
          __typename
          pageID
          notes
          createdAt
          updatedAt
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSlideMutation>response.data.createSlide;
  }
  async UpdateSlide(
    input: UpdateSlideInput,
    condition?: ModelSlideConditionInput
  ): Promise<UpdateSlideMutation> {
    const statement = `mutation UpdateSlide($input: UpdateSlideInput!, $condition: ModelSlideConditionInput) {
        updateSlide(input: $input, condition: $condition) {
          __typename
          pageID
          notes
          createdAt
          updatedAt
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSlideMutation>response.data.updateSlide;
  }
  async DeleteSlide(
    input: DeleteSlideInput,
    condition?: ModelSlideConditionInput
  ): Promise<DeleteSlideMutation> {
    const statement = `mutation DeleteSlide($input: DeleteSlideInput!, $condition: ModelSlideConditionInput) {
        deleteSlide(input: $input, condition: $condition) {
          __typename
          pageID
          notes
          createdAt
          updatedAt
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSlideMutation>response.data.deleteSlide;
  }
  async CreateSlideContent(
    input: CreateSlideContentInput,
    condition?: ModelSlideContentConditionInput
  ): Promise<CreateSlideContentMutation> {
    const statement = `mutation CreateSlideContent($input: CreateSlideContentInput!, $condition: ModelSlideContentConditionInput) {
        createSlideContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSlideContentMutation>response.data.createSlideContent;
  }
  async UpdateSlideContent(
    input: UpdateSlideContentInput,
    condition?: ModelSlideContentConditionInput
  ): Promise<UpdateSlideContentMutation> {
    const statement = `mutation UpdateSlideContent($input: UpdateSlideContentInput!, $condition: ModelSlideContentConditionInput) {
        updateSlideContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSlideContentMutation>response.data.updateSlideContent;
  }
  async DeleteSlideContent(
    input: DeleteSlideContentInput,
    condition?: ModelSlideContentConditionInput
  ): Promise<DeleteSlideContentMutation> {
    const statement = `mutation DeleteSlideContent($input: DeleteSlideContentInput!, $condition: ModelSlideContentConditionInput) {
        deleteSlideContent(input: $input, condition: $condition) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSlideContentMutation>response.data.deleteSlideContent;
  }
  async CreateUser(
    input: CreateUserInput,
    condition?: ModelUserConditionInput
  ): Promise<CreateUserMutation> {
    const statement = `mutation CreateUser($input: CreateUserInput!, $condition: ModelUserConditionInput) {
        createUser(input: $input, condition: $condition) {
          __typename
          id
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          responses {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateUserMutation>response.data.createUser;
  }
  async UpdateUser(
    input: UpdateUserInput,
    condition?: ModelUserConditionInput
  ): Promise<UpdateUserMutation> {
    const statement = `mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
        updateUser(input: $input, condition: $condition) {
          __typename
          id
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          responses {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateUserMutation>response.data.updateUser;
  }
  async DeleteUser(
    input: DeleteUserInput,
    condition?: ModelUserConditionInput
  ): Promise<DeleteUserMutation> {
    const statement = `mutation DeleteUser($input: DeleteUserInput!, $condition: ModelUserConditionInput) {
        deleteUser(input: $input, condition: $condition) {
          __typename
          id
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          responses {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteUserMutation>response.data.deleteUser;
  }
  async CustomCreateResponse(
    questionID: string,
    choices?: Array<string | null>,
    value?: string,
    userID?: string
  ): Promise<CustomCreateResponseQuery> {
    const statement = `query CustomCreateResponse($questionID: ID!, $choices: [String], $value: String, $userID: ID) {
        customCreateResponse(questionID: $questionID, choices: $choices, value: $value, userID: $userID) {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      questionID
    };
    if (choices) {
      gqlAPIServiceArguments.choices = choices;
    }
    if (value) {
      gqlAPIServiceArguments.value = value;
    }
    if (userID) {
      gqlAPIServiceArguments.userID = userID;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CustomCreateResponseQuery>response.data.customCreateResponse;
  }
  async SetModulesOrder(
    moduleIDs: Array<string | null>
  ): Promise<boolean | null> {
    const statement = `query SetModulesOrder($moduleIDs: [String]!) {
        setModulesOrder(moduleIDs: $moduleIDs)
      }`;
    const gqlAPIServiceArguments: any = {
      moduleIDs
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <boolean | null>response.data.setModulesOrder;
  }
  async SetNavigationNodesOrder(
    navigationNodeIDs: Array<string | null>
  ): Promise<boolean | null> {
    const statement = `query SetNavigationNodesOrder($navigationNodeIDs: [String]!) {
        setNavigationNodesOrder(navigationNodeIDs: $navigationNodeIDs)
      }`;
    const gqlAPIServiceArguments: any = {
      navigationNodeIDs
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <boolean | null>response.data.setNavigationNodesOrder;
  }
  async UpdateRpmAvatarUrl(
    username: string,
    rpmAvatarURL: string
  ): Promise<boolean | null> {
    const statement = `query UpdateRpmAvatarUrl($username: String!, $rpmAvatarURL: String!) {
        updateRPMAvatarURL(username: $username, rpmAvatarURL: $rpmAvatarURL)
      }`;
    const gqlAPIServiceArguments: any = {
      username,
      rpmAvatarURL
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <boolean | null>response.data.updateRPMAvatarURL;
  }
  async GetInstitution(id: string): Promise<GetInstitutionQuery> {
    const statement = `query GetInstitution($id: ID!) {
        getInstitution(id: $id) {
          __typename
          id
          name
          logo
          navigationNodeLevelNames
          createdAt
          updatedAt
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          navigationNodeConnections {
            __typename
            nextToken
          }
          users {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetInstitutionQuery>response.data.getInstitution;
  }
  async ListInstitutions(
    filter?: ModelInstitutionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListInstitutionsQuery> {
    const statement = `query ListInstitutions($filter: ModelInstitutionFilterInput, $limit: Int, $nextToken: String) {
        listInstitutions(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListInstitutionsQuery>response.data.listInstitutions;
  }
  async GetAnswer(id: string): Promise<GetAnswerQuery> {
    const statement = `query GetAnswer($id: ID!) {
        getAnswer(id: $id) {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetAnswerQuery>response.data.getAnswer;
  }
  async ListAnswers(
    filter?: ModelAnswerFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListAnswersQuery> {
    const statement = `query ListAnswers($filter: ModelAnswerFilterInput, $limit: Int, $nextToken: String) {
        listAnswers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListAnswersQuery>response.data.listAnswers;
  }
  async GetAnswerChoice(id: string): Promise<GetAnswerChoiceQuery> {
    const statement = `query GetAnswerChoice($id: ID!) {
        getAnswerChoice(id: $id) {
          __typename
          id
          choiceId
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetAnswerChoiceQuery>response.data.getAnswerChoice;
  }
  async ListAnswerChoices(
    filter?: ModelAnswerChoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListAnswerChoicesQuery> {
    const statement = `query ListAnswerChoices($filter: ModelAnswerChoiceFilterInput, $limit: Int, $nextToken: String) {
        listAnswerChoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            choiceId
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListAnswerChoicesQuery>response.data.listAnswerChoices;
  }
  async GetAnswerContent(id: string): Promise<GetAnswerContentQuery> {
    const statement = `query GetAnswerContent($id: ID!) {
        getAnswerContent(id: $id) {
          __typename
          id
          order
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetAnswerContentQuery>response.data.getAnswerContent;
  }
  async ListAnswerContents(
    filter?: ModelAnswerContentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListAnswerContentsQuery> {
    const statement = `query ListAnswerContents($filter: ModelAnswerContentFilterInput, $limit: Int, $nextToken: String) {
        listAnswerContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            order
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListAnswerContentsQuery>response.data.listAnswerContents;
  }
  async GetChoice(id: string): Promise<GetChoiceQuery> {
    const statement = `query GetChoice($id: ID!) {
        getChoice(id: $id) {
          __typename
          id
          value
          order
          createdAt
          updatedAt
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetChoiceQuery>response.data.getChoice;
  }
  async ListChoices(
    filter?: ModelChoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListChoicesQuery> {
    const statement = `query ListChoices($filter: ModelChoiceFilterInput, $limit: Int, $nextToken: String) {
        listChoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListChoicesQuery>response.data.listChoices;
  }
  async GetContent(id: string): Promise<GetContentQuery> {
    const statement = `query GetContent($id: ID!) {
        getContent(id: $id) {
          __typename
          id
          type
          value
          contentUserId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          answers {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          slides {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetContentQuery>response.data.getContent;
  }
  async ListContents(
    filter?: ModelContentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListContentsQuery> {
    const statement = `query ListContents($filter: ModelContentFilterInput, $limit: Int, $nextToken: String) {
        listContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListContentsQuery>response.data.listContents;
  }
  async ContentsByUserCreatedAt(
    contentUserId?: string,
    createdAt?: ModelStringKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelContentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ContentsByUserCreatedAtQuery> {
    const statement = `query ContentsByUserCreatedAt($contentUserId: ID, $createdAt: ModelStringKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelContentFilterInput, $limit: Int, $nextToken: String) {
        contentsByUserCreatedAt(contentUserId: $contentUserId, createdAt: $createdAt, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (contentUserId) {
      gqlAPIServiceArguments.contentUserId = contentUserId;
    }
    if (createdAt) {
      gqlAPIServiceArguments.createdAt = createdAt;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ContentsByUserCreatedAtQuery>response.data.contentsByUserCreatedAt;
  }
  async GetModule(id: string): Promise<GetModuleQuery> {
    const statement = `query GetModule($id: ID!) {
        getModule(id: $id) {
          __typename
          id
          label
          image
          description
          order
          active
          locked
          type
          visible
          public
          ownerID
          navigationNodeID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          navigationNode {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          pages {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetModuleQuery>response.data.getModule;
  }
  async ListModules(
    filter?: ModelModuleFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListModulesQuery> {
    const statement = `query ListModules($filter: ModelModuleFilterInput, $limit: Int, $nextToken: String) {
        listModules(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListModulesQuery>response.data.listModules;
  }
  async GetModuleContent(id: string): Promise<GetModuleContentQuery> {
    const statement = `query GetModuleContent($id: ID!) {
        getModuleContent(id: $id) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetModuleContentQuery>response.data.getModuleContent;
  }
  async ListModuleContents(
    filter?: ModelModuleContentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListModuleContentsQuery> {
    const statement = `query ListModuleContents($filter: ModelModuleContentFilterInput, $limit: Int, $nextToken: String) {
        listModuleContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            order
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListModuleContentsQuery>response.data.listModuleContents;
  }
  async GetNavigationNode(id: string): Promise<GetNavigationNodeQuery> {
    const statement = `query GetNavigationNode($id: ID!) {
        getNavigationNode(id: $id) {
          __typename
          id
          label
          image
          description
          active
          order
          visible
          ownerID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          modules {
            __typename
            nextToken
          }
          parentConnection {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          childConnections {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNavigationNodeQuery>response.data.getNavigationNode;
  }
  async ListNavigationNodes(
    filter?: ModelNavigationNodeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNavigationNodesQuery> {
    const statement = `query ListNavigationNodes($filter: ModelNavigationNodeFilterInput, $limit: Int, $nextToken: String) {
        listNavigationNodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNavigationNodesQuery>response.data.listNavigationNodes;
  }
  async GetNavigationNodeConnection(
    id: string
  ): Promise<GetNavigationNodeConnectionQuery> {
    const statement = `query GetNavigationNodeConnection($id: ID!) {
        getNavigationNodeConnection(id: $id) {
          __typename
          id
          order
          parentId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          child {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          parent {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNavigationNodeConnectionQuery>(
      response.data.getNavigationNodeConnection
    );
  }
  async ListNavigationNodeConnections(
    filter?: ModelNavigationNodeConnectionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNavigationNodeConnectionsQuery> {
    const statement = `query ListNavigationNodeConnections($filter: ModelNavigationNodeConnectionFilterInput, $limit: Int, $nextToken: String) {
        listNavigationNodeConnections(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNavigationNodeConnectionsQuery>(
      response.data.listNavigationNodeConnections
    );
  }
  async GetPage(id: string): Promise<GetPageQuery> {
    const statement = `query GetPage($id: ID!) {
        getPage(id: $id) {
          __typename
          id
          order
          type
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPageQuery>response.data.getPage;
  }
  async ListPages(
    filter?: ModelPageFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPagesQuery> {
    const statement = `query ListPages($filter: ModelPageFilterInput, $limit: Int, $nextToken: String) {
        listPages(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPagesQuery>response.data.listPages;
  }
  async GetQuestion(id: string): Promise<GetQuestionQuery> {
    const statement = `query GetQuestion($id: ID!) {
        getQuestion(id: $id) {
          __typename
          id
          value
          description
          type
          data
          createdAt
          updatedAt
          answers {
            __typename
            nextToken
          }
          choices {
            __typename
            nextToken
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetQuestionQuery>response.data.getQuestion;
  }
  async ListQuestions(
    filter?: ModelQuestionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListQuestionsQuery> {
    const statement = `query ListQuestions($filter: ModelQuestionFilterInput, $limit: Int, $nextToken: String) {
        listQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListQuestionsQuery>response.data.listQuestions;
  }
  async GetQuestionContent(id: string): Promise<GetQuestionContentQuery> {
    const statement = `query GetQuestionContent($id: ID!) {
        getQuestionContent(id: $id) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetQuestionContentQuery>response.data.getQuestionContent;
  }
  async ListQuestionContents(
    filter?: ModelQuestionContentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListQuestionContentsQuery> {
    const statement = `query ListQuestionContents($filter: ModelQuestionContentFilterInput, $limit: Int, $nextToken: String) {
        listQuestionContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            order
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListQuestionContentsQuery>response.data.listQuestionContents;
  }
  async GetResponse(
    moduleID: string,
    userID: string,
    questionID: string
  ): Promise<GetResponseQuery> {
    const statement = `query GetResponse($moduleID: ID!, $userID: ID!, $questionID: ID!) {
        getResponse(moduleID: $moduleID, userID: $userID, questionID: $questionID) {
          __typename
          id
          moduleID
          questionID
          userID
          value
          correctness
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          run {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      moduleID,
      userID,
      questionID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetResponseQuery>response.data.getResponse;
  }
  async ListResponses(
    moduleID?: string,
    userIDQuestionID?: ModelResponsePrimaryCompositeKeyConditionInput,
    filter?: ModelResponseFilterInput,
    limit?: number,
    nextToken?: string,
    sortDirection?: ModelSortDirection
  ): Promise<ListResponsesQuery> {
    const statement = `query ListResponses($moduleID: ID, $userIDQuestionID: ModelResponsePrimaryCompositeKeyConditionInput, $filter: ModelResponseFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listResponses(moduleID: $moduleID, userIDQuestionID: $userIDQuestionID, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            id
            moduleID
            questionID
            userID
            value
            correctness
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (moduleID) {
      gqlAPIServiceArguments.moduleID = moduleID;
    }
    if (userIDQuestionID) {
      gqlAPIServiceArguments.userIDQuestionID = userIDQuestionID;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListResponsesQuery>response.data.listResponses;
  }
  async GetResponseChoice(id: string): Promise<GetResponseChoiceQuery> {
    const statement = `query GetResponseChoice($id: ID!) {
        getResponseChoice(id: $id) {
          __typename
          id
          responseID
          choiceID
          createdAt
          updatedAt
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetResponseChoiceQuery>response.data.getResponseChoice;
  }
  async ListResponseChoices(
    filter?: ModelResponseChoiceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListResponseChoicesQuery> {
    const statement = `query ListResponseChoices($filter: ModelResponseChoiceFilterInput, $limit: Int, $nextToken: String) {
        listResponseChoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            responseID
            choiceID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListResponseChoicesQuery>response.data.listResponseChoices;
  }
  async GetRun(moduleID: string, userID: string): Promise<GetRunQuery> {
    const statement = `query GetRun($moduleID: ID!, $userID: ID!) {
        getRun(moduleID: $moduleID, userID: $userID) {
          __typename
          moduleID
          userID
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          responses {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      moduleID,
      userID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetRunQuery>response.data.getRun;
  }
  async ListRuns(
    moduleID?: string,
    userID?: ModelIDKeyConditionInput,
    filter?: ModelRunFilterInput,
    limit?: number,
    nextToken?: string,
    sortDirection?: ModelSortDirection
  ): Promise<ListRunsQuery> {
    const statement = `query ListRuns($moduleID: ID, $userID: ModelIDKeyConditionInput, $filter: ModelRunFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listRuns(moduleID: $moduleID, userID: $userID, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (moduleID) {
      gqlAPIServiceArguments.moduleID = moduleID;
    }
    if (userID) {
      gqlAPIServiceArguments.userID = userID;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListRunsQuery>response.data.listRuns;
  }
  async GetSlide(pageID: string): Promise<GetSlideQuery> {
    const statement = `query GetSlide($pageID: ID!) {
        getSlide(pageID: $pageID) {
          __typename
          pageID
          notes
          createdAt
          updatedAt
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      pageID
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSlideQuery>response.data.getSlide;
  }
  async ListSlides(
    pageID?: string,
    filter?: ModelSlideFilterInput,
    limit?: number,
    nextToken?: string,
    sortDirection?: ModelSortDirection
  ): Promise<ListSlidesQuery> {
    const statement = `query ListSlides($pageID: ID, $filter: ModelSlideFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listSlides(pageID: $pageID, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (pageID) {
      gqlAPIServiceArguments.pageID = pageID;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSlidesQuery>response.data.listSlides;
  }
  async GetSlideContent(id: string): Promise<GetSlideContentQuery> {
    const statement = `query GetSlideContent($id: ID!) {
        getSlideContent(id: $id) {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSlideContentQuery>response.data.getSlideContent;
  }
  async ListSlideContents(
    filter?: ModelSlideContentFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListSlideContentsQuery> {
    const statement = `query ListSlideContents($filter: ModelSlideContentFilterInput, $limit: Int, $nextToken: String) {
        listSlideContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            order
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSlideContentsQuery>response.data.listSlideContents;
  }
  async GetUser(id: string): Promise<GetUserQuery> {
    const statement = `query GetUser($id: ID!) {
        getUser(id: $id) {
          __typename
          id
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          responses {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetUserQuery>response.data.getUser;
  }
  async ListUsers(
    filter?: ModelUserFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListUsersQuery> {
    const statement = `query ListUsers($filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
        listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListUsersQuery>response.data.listUsers;
  }
  OnCreateInstitutionListener: Observable<
    SubscriptionResponse<OnCreateInstitutionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateInstitution {
        onCreateInstitution {
          __typename
          id
          name
          logo
          navigationNodeLevelNames
          createdAt
          updatedAt
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          navigationNodeConnections {
            __typename
            nextToken
          }
          users {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateInstitutionSubscription>>;

  OnUpdateInstitutionListener: Observable<
    SubscriptionResponse<OnUpdateInstitutionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateInstitution {
        onUpdateInstitution {
          __typename
          id
          name
          logo
          navigationNodeLevelNames
          createdAt
          updatedAt
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          navigationNodeConnections {
            __typename
            nextToken
          }
          users {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateInstitutionSubscription>>;

  OnDeleteInstitutionListener: Observable<
    SubscriptionResponse<OnDeleteInstitutionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteInstitution {
        onDeleteInstitution {
          __typename
          id
          name
          logo
          navigationNodeLevelNames
          createdAt
          updatedAt
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          navigationNodeConnections {
            __typename
            nextToken
          }
          users {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteInstitutionSubscription>>;

  OnCreateAnswerListener: Observable<
    SubscriptionResponse<OnCreateAnswerSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateAnswer {
        onCreateAnswer {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateAnswerSubscription>>;

  OnUpdateAnswerListener: Observable<
    SubscriptionResponse<OnUpdateAnswerSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateAnswer {
        onUpdateAnswer {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateAnswerSubscription>>;

  OnDeleteAnswerListener: Observable<
    SubscriptionResponse<OnDeleteAnswerSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteAnswer {
        onDeleteAnswer {
          __typename
          id
          correctness
          default
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          contents {
            __typename
            nextToken
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteAnswerSubscription>>;

  OnCreateAnswerChoiceListener: Observable<
    SubscriptionResponse<OnCreateAnswerChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateAnswerChoice {
        onCreateAnswerChoice {
          __typename
          id
          choiceId
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateAnswerChoiceSubscription>>;

  OnUpdateAnswerChoiceListener: Observable<
    SubscriptionResponse<OnUpdateAnswerChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateAnswerChoice {
        onUpdateAnswerChoice {
          __typename
          id
          choiceId
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateAnswerChoiceSubscription>>;

  OnDeleteAnswerChoiceListener: Observable<
    SubscriptionResponse<OnDeleteAnswerChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteAnswerChoice {
        onDeleteAnswerChoice {
          __typename
          id
          choiceId
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteAnswerChoiceSubscription>>;

  OnCreateAnswerContentListener: Observable<
    SubscriptionResponse<OnCreateAnswerContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateAnswerContent {
        onCreateAnswerContent {
          __typename
          id
          order
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateAnswerContentSubscription>>;

  OnUpdateAnswerContentListener: Observable<
    SubscriptionResponse<OnUpdateAnswerContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateAnswerContent {
        onUpdateAnswerContent {
          __typename
          id
          order
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateAnswerContentSubscription>>;

  OnDeleteAnswerContentListener: Observable<
    SubscriptionResponse<OnDeleteAnswerContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteAnswerContent {
        onDeleteAnswerContent {
          __typename
          id
          order
          createdAt
          updatedAt
          answer {
            __typename
            id
            correctness
            default
            createdAt
            updatedAt
          }
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteAnswerContentSubscription>>;

  OnCreateChoiceListener: Observable<
    SubscriptionResponse<OnCreateChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateChoice {
        onCreateChoice {
          __typename
          id
          value
          order
          createdAt
          updatedAt
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateChoiceSubscription>>;

  OnUpdateChoiceListener: Observable<
    SubscriptionResponse<OnUpdateChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateChoice {
        onUpdateChoice {
          __typename
          id
          value
          order
          createdAt
          updatedAt
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateChoiceSubscription>>;

  OnDeleteChoiceListener: Observable<
    SubscriptionResponse<OnDeleteChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteChoice {
        onDeleteChoice {
          __typename
          id
          value
          order
          createdAt
          updatedAt
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteChoiceSubscription>>;

  OnCreateContentListener: Observable<
    SubscriptionResponse<OnCreateContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateContent {
        onCreateContent {
          __typename
          id
          type
          value
          contentUserId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          answers {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          slides {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateContentSubscription>>;

  OnUpdateContentListener: Observable<
    SubscriptionResponse<OnUpdateContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateContent {
        onUpdateContent {
          __typename
          id
          type
          value
          contentUserId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          answers {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          slides {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateContentSubscription>>;

  OnDeleteContentListener: Observable<
    SubscriptionResponse<OnDeleteContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteContent {
        onDeleteContent {
          __typename
          id
          type
          value
          contentUserId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          answers {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          slides {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteContentSubscription>>;

  OnCreateModuleListener: Observable<
    SubscriptionResponse<OnCreateModuleSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateModule {
        onCreateModule {
          __typename
          id
          label
          image
          description
          order
          active
          locked
          type
          visible
          public
          ownerID
          navigationNodeID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          navigationNode {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          pages {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateModuleSubscription>>;

  OnUpdateModuleListener: Observable<
    SubscriptionResponse<OnUpdateModuleSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateModule {
        onUpdateModule {
          __typename
          id
          label
          image
          description
          order
          active
          locked
          type
          visible
          public
          ownerID
          navigationNodeID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          navigationNode {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          pages {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateModuleSubscription>>;

  OnDeleteModuleListener: Observable<
    SubscriptionResponse<OnDeleteModuleSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteModule {
        onDeleteModule {
          __typename
          id
          label
          image
          description
          order
          active
          locked
          type
          visible
          public
          ownerID
          navigationNodeID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          navigationNode {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          pages {
            __typename
            nextToken
          }
          questions {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteModuleSubscription>>;

  OnCreateModuleContentListener: Observable<
    SubscriptionResponse<OnCreateModuleContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateModuleContent {
        onCreateModuleContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateModuleContentSubscription>>;

  OnUpdateModuleContentListener: Observable<
    SubscriptionResponse<OnUpdateModuleContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateModuleContent {
        onUpdateModuleContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateModuleContentSubscription>>;

  OnDeleteModuleContentListener: Observable<
    SubscriptionResponse<OnDeleteModuleContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteModuleContent {
        onDeleteModuleContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteModuleContentSubscription>>;

  OnCreateNavigationNodeListener: Observable<
    SubscriptionResponse<OnCreateNavigationNodeSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateNavigationNode {
        onCreateNavigationNode {
          __typename
          id
          label
          image
          description
          active
          order
          visible
          ownerID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          modules {
            __typename
            nextToken
          }
          parentConnection {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          childConnections {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateNavigationNodeSubscription>>;

  OnUpdateNavigationNodeListener: Observable<
    SubscriptionResponse<OnUpdateNavigationNodeSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateNavigationNode {
        onUpdateNavigationNode {
          __typename
          id
          label
          image
          description
          active
          order
          visible
          ownerID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          modules {
            __typename
            nextToken
          }
          parentConnection {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          childConnections {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateNavigationNodeSubscription>>;

  OnDeleteNavigationNodeListener: Observable<
    SubscriptionResponse<OnDeleteNavigationNodeSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteNavigationNode {
        onDeleteNavigationNode {
          __typename
          id
          label
          image
          description
          active
          order
          visible
          ownerID
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          modules {
            __typename
            nextToken
          }
          parentConnection {
            __typename
            id
            order
            parentId
            createdAt
            updatedAt
          }
          childConnections {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteNavigationNodeSubscription>>;

  OnCreateNavigationNodeConnectionListener: Observable<
    SubscriptionResponse<OnCreateNavigationNodeConnectionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateNavigationNodeConnection {
        onCreateNavigationNodeConnection {
          __typename
          id
          order
          parentId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          child {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          parent {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnCreateNavigationNodeConnectionSubscription>
  >;

  OnUpdateNavigationNodeConnectionListener: Observable<
    SubscriptionResponse<OnUpdateNavigationNodeConnectionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateNavigationNodeConnection {
        onUpdateNavigationNodeConnection {
          __typename
          id
          order
          parentId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          child {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          parent {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnUpdateNavigationNodeConnectionSubscription>
  >;

  OnDeleteNavigationNodeConnectionListener: Observable<
    SubscriptionResponse<OnDeleteNavigationNodeConnectionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteNavigationNodeConnection {
        onDeleteNavigationNodeConnection {
          __typename
          id
          order
          parentId
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          child {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
          parent {
            __typename
            id
            label
            image
            description
            active
            order
            visible
            ownerID
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnDeleteNavigationNodeConnectionSubscription>
  >;

  OnCreatePageListener: Observable<
    SubscriptionResponse<OnCreatePageSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreatePage {
        onCreatePage {
          __typename
          id
          order
          type
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreatePageSubscription>>;

  OnUpdatePageListener: Observable<
    SubscriptionResponse<OnUpdatePageSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdatePage {
        onUpdatePage {
          __typename
          id
          order
          type
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdatePageSubscription>>;

  OnDeletePageListener: Observable<
    SubscriptionResponse<OnDeletePageSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeletePage {
        onDeletePage {
          __typename
          id
          order
          type
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeletePageSubscription>>;

  OnCreateQuestionListener: Observable<
    SubscriptionResponse<OnCreateQuestionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateQuestion {
        onCreateQuestion {
          __typename
          id
          value
          description
          type
          data
          createdAt
          updatedAt
          answers {
            __typename
            nextToken
          }
          choices {
            __typename
            nextToken
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateQuestionSubscription>>;

  OnUpdateQuestionListener: Observable<
    SubscriptionResponse<OnUpdateQuestionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateQuestion {
        onUpdateQuestion {
          __typename
          id
          value
          description
          type
          data
          createdAt
          updatedAt
          answers {
            __typename
            nextToken
          }
          choices {
            __typename
            nextToken
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateQuestionSubscription>>;

  OnDeleteQuestionListener: Observable<
    SubscriptionResponse<OnDeleteQuestionSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteQuestion {
        onDeleteQuestion {
          __typename
          id
          value
          description
          type
          data
          createdAt
          updatedAt
          answers {
            __typename
            nextToken
          }
          choices {
            __typename
            nextToken
          }
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteQuestionSubscription>>;

  OnCreateQuestionContentListener: Observable<
    SubscriptionResponse<OnCreateQuestionContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateQuestionContent {
        onCreateQuestionContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateQuestionContentSubscription>>;

  OnUpdateQuestionContentListener: Observable<
    SubscriptionResponse<OnUpdateQuestionContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateQuestionContent {
        onUpdateQuestionContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateQuestionContentSubscription>>;

  OnDeleteQuestionContentListener: Observable<
    SubscriptionResponse<OnDeleteQuestionContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteQuestionContent {
        onDeleteQuestionContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          question {
            __typename
            id
            value
            description
            type
            data
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteQuestionContentSubscription>>;

  OnCreateResponseListener: Observable<
    SubscriptionResponse<OnCreateResponseSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateResponse {
        onCreateResponse {
          __typename
          id
          moduleID
          questionID
          userID
          value
          correctness
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          run {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateResponseSubscription>>;

  OnUpdateResponseListener: Observable<
    SubscriptionResponse<OnUpdateResponseSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateResponse {
        onUpdateResponse {
          __typename
          id
          moduleID
          questionID
          userID
          value
          correctness
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          run {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateResponseSubscription>>;

  OnDeleteResponseListener: Observable<
    SubscriptionResponse<OnDeleteResponseSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteResponse {
        onDeleteResponse {
          __typename
          id
          moduleID
          questionID
          userID
          value
          correctness
          createdAt
          updatedAt
          choices {
            __typename
            nextToken
          }
          run {
            __typename
            moduleID
            userID
            createdAt
            updatedAt
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteResponseSubscription>>;

  OnCreateResponseChoiceListener: Observable<
    SubscriptionResponse<OnCreateResponseChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateResponseChoice {
        onCreateResponseChoice {
          __typename
          id
          responseID
          choiceID
          createdAt
          updatedAt
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateResponseChoiceSubscription>>;

  OnUpdateResponseChoiceListener: Observable<
    SubscriptionResponse<OnUpdateResponseChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateResponseChoice {
        onUpdateResponseChoice {
          __typename
          id
          responseID
          choiceID
          createdAt
          updatedAt
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateResponseChoiceSubscription>>;

  OnDeleteResponseChoiceListener: Observable<
    SubscriptionResponse<OnDeleteResponseChoiceSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteResponseChoice {
        onDeleteResponseChoice {
          __typename
          id
          responseID
          choiceID
          createdAt
          updatedAt
          choice {
            __typename
            id
            value
            order
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteResponseChoiceSubscription>>;

  OnCreateRunListener: Observable<
    SubscriptionResponse<OnCreateRunSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateRun {
        onCreateRun {
          __typename
          moduleID
          userID
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          responses {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateRunSubscription>>;

  OnUpdateRunListener: Observable<
    SubscriptionResponse<OnUpdateRunSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateRun {
        onUpdateRun {
          __typename
          moduleID
          userID
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          responses {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateRunSubscription>>;

  OnDeleteRunListener: Observable<
    SubscriptionResponse<OnDeleteRunSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteRun {
        onDeleteRun {
          __typename
          moduleID
          userID
          createdAt
          updatedAt
          module {
            __typename
            id
            label
            image
            description
            order
            active
            locked
            type
            visible
            public
            ownerID
            navigationNodeID
            createdAt
            updatedAt
          }
          responses {
            __typename
            nextToken
          }
          user {
            __typename
            id
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteRunSubscription>>;

  OnCreateSlideListener: Observable<
    SubscriptionResponse<OnCreateSlideSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateSlide {
        onCreateSlide {
          __typename
          pageID
          notes
          createdAt
          updatedAt
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateSlideSubscription>>;

  OnUpdateSlideListener: Observable<
    SubscriptionResponse<OnUpdateSlideSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateSlide {
        onUpdateSlide {
          __typename
          pageID
          notes
          createdAt
          updatedAt
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateSlideSubscription>>;

  OnDeleteSlideListener: Observable<
    SubscriptionResponse<OnDeleteSlideSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteSlide {
        onDeleteSlide {
          __typename
          pageID
          notes
          createdAt
          updatedAt
          page {
            __typename
            id
            order
            type
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteSlideSubscription>>;

  OnCreateSlideContentListener: Observable<
    SubscriptionResponse<OnCreateSlideContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateSlideContent {
        onCreateSlideContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateSlideContentSubscription>>;

  OnUpdateSlideContentListener: Observable<
    SubscriptionResponse<OnUpdateSlideContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateSlideContent {
        onUpdateSlideContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateSlideContentSubscription>>;

  OnDeleteSlideContentListener: Observable<
    SubscriptionResponse<OnDeleteSlideContentSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteSlideContent {
        onDeleteSlideContent {
          __typename
          id
          order
          createdAt
          updatedAt
          content {
            __typename
            id
            type
            value
            contentUserId
            createdAt
            updatedAt
          }
          slide {
            __typename
            pageID
            notes
            createdAt
            updatedAt
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteSlideContentSubscription>>;

  OnCreateUserListener: Observable<
    SubscriptionResponse<OnCreateUserSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateUser {
        onCreateUser {
          __typename
          id
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          responses {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateUserSubscription>>;

  OnUpdateUserListener: Observable<
    SubscriptionResponse<OnUpdateUserSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateUser {
        onUpdateUser {
          __typename
          id
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          responses {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateUserSubscription>>;

  OnDeleteUserListener: Observable<
    SubscriptionResponse<OnDeleteUserSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteUser {
        onDeleteUser {
          __typename
          id
          createdAt
          updatedAt
          institution {
            __typename
            id
            name
            logo
            navigationNodeLevelNames
            createdAt
            updatedAt
          }
          contents {
            __typename
            nextToken
          }
          modules {
            __typename
            nextToken
          }
          navigationNodes {
            __typename
            nextToken
          }
          responses {
            __typename
            nextToken
          }
          runs {
            __typename
            nextToken
          }
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteUserSubscription>>;
}
